import React from 'react';
import '../template-file-css/document-file-template.css';


export const LBS_AdultIntake = ({ itemsRef, showErrorFor }) => {

    return (
        <form id='LBS_AdultIntake' className='file-pdf-document'>
            <div className='file-template'>
                <h3>CLIENT CHART (ADULT) </h3>
                <h4>TABLE OF CONTENTS </h4>
            <ol>
                <li>Intake packet</li>
                 <ol type='A'>
                    <li>Record of Access</li>
                    <li>New Client Checklist</li>
                    <li>Intake Face Sheet</li>
                    <li>Identification Cards</li>
                    <li>TMHP verification sheet</li>
                    <li>Copy of Insurance Card</li>
                    <li>Client Data</li>
                    <li>Medical History Questionnaire</li>
                    <li>Consent for Treatment</li>
                    <li>Medication Acknowledgement Waiver</li>
                    <li>Client Rights and Responsibility</li>
                    <li>Notification of receipts or recipient rights</li>
                    <li>Privacy Notice Acknowledgement (HIPAA)</li>
                    <li>How to make a Complaint</li>
                    <li>Crisis Response</li>
                    <li>Rights to Appeal Process</li>
                    <li>Abuse and Neglect Procedure</li>
                    <li>Emergency preparedness questionnaire</li>
                    <li>Advanced Directives</li>
                    <li>Client Orientation Checklist</li>
                    <li>Freedom of choice form</li>
                    <li>Consent to release or obtain information</li>
                      <ol type='a'>
                         <li>pcp Information</li>
                         <li>Emergency Contact</li>
                      </ol>
                 </ol>
                <li>PA</li>
                <li>Assessment</li>
                 <ol type='a'>
                    <li>ANSA</li>
                    <li>OTR</li>
                    <li>Diagnosis Sheet</li>
                    <li>Psychosocial Assessment</li>
                 </ol>
                <li>Treatment Plan</li>
                <li>Psych Evaluation</li>
                <li>Reauthorization</li>
                <li>Meds/Labs</li>
                <li>Fax Correspondence</li>
             </ol>
             <p className='w-750'><b>*Consumer Satisfaction Survey- Intake and Screening</b></p>
             <h3>RECORD OF ACCESS</h3>
             <table>
                    <tr>
                        <td className='w-150'> <span className='eleHeader'>DATE</span> </td>
                        <td className='w-187'> <span className='eleHeader'>Reason for Access </span> </td>
                        <td className='w-200'> <span className='eleHeader'>Person Accessing Record</span> </td>
                        <td className='w-187'> <span className='eleHeader'>Title</span> </td>
                    </tr>
                    <tr>
                        <td className='w-150'> <input type='date' id='dtDate_1' name='dtDate_1' className='add-only' /> </td>
                        <td className='w-187'> <input type='text' id='txtReasonAccess_1' name='txtReasonAccess_1' className='add-only' /> </td>
                        <td className='w-200'> <input type='text' id='txtPersonAccessing_1' name='txtPersonAccessing_1' className='add-only' /> </td>
                        <td className='w-187'> <input type='text' id='txtTitle_1' name='txtTitle_1' className='add-only' /> </td>
                    </tr>
                    <tr>
                        <td className='w-150'> <input type='date' id='dtDate_2' name='dtDate_2' className='add-only' /> </td>
                        <td className='w-187'> <input type='text' id='txtReasonAccess_2' name='txtReasonAccess_2' className='add-only' /> </td>
                        <td className='w-200'> <input type='text' id='txtPersonAccessing_2' name='txtPersonAccessing_2' className='add-only' /> </td>
                        <td className='w-187'> <input type='text' id='txtTitle_2' name='txtTitle_2' className='add-only' /> </td>
                    </tr>
                    <tr>
                        <td className='w-150'> <input type='date' id='dtDate_3' name='dtDate_3' className='add-only' /> </td>
                        <td className='w-187'> <input type='text' id='txtReasonAccess_3' name='txtReasonAccess_3' className='add-only' /> </td>
                        <td className='w-200'> <input type='text' id='txtPersonAccessing_3' name='txtPersonAccessing_3' className='add-only' /> </td>
                        <td className='w-187'> <input type='text' id='txtTitle_3' name='txtTitle_3' className='add-only' /> </td>
                    </tr>
                    <tr>
                        <td className='w-150'> <input type='date' id='dtDate_4' name='dtDate_4' className='add-only' /> </td>
                        <td className='w-187'> <input type='text' id='txtReasonAccess_4' name='txtReasonAccess_4' className='add-only' /> </td>
                        <td className='w-200'> <input type='text' id='txtPersonAccessing_4' name='txtPersonAccessing_4' className='add-only' /> </td>
                        <td className='w-187'> <input type='text' id='txtTitle_4' name='txtTitle_4' className='add-only' /> </td>
                    </tr>
                    <tr>
                        <td className='w-150'> <input type='date' id='dtDate_5' name='dtDate_5' className='add-only' /> </td>
                        <td className='w-187'> <input type='text' id='txtReasonAccess_5' name='txtReasonAccess_5' className='add-only' /> </td>
                        <td className='w-200'> <input type='text' id='txtPersonAccessing_5' name='txtPersonAccessing_5' className='add-only' /> </td>
                        <td className='w-187'> <input type='text' id='txtTitle_5' name='txtTitle_5' className='add-only' /> </td>
                    </tr>
                    <tr>
                        <td className='w-150'> <input type='date' id='dtDate_6' name='dtDate_6' className='add-only' /> </td>
                        <td className='w-187'> <input type='text' id='txtReasonAccess_6' name='txtReasonAccess_6' className='add-only' /> </td>
                        <td className='w-200'> <input type='text' id='txtPersonAccessing_6' name='txtPersonAccessing_6' className='add-only' /> </td>
                        <td className='w-187'> <input type='text' id='txtTitle_6' name='txtTitle_6' className='add-only' /> </td>
                    </tr>
                    <tr>
                        <td className='w-150'> <input type='date' id='dtDate_7' name='dtDate_7' className='add-only' /> </td>
                        <td className='w-187'> <input type='text' id='txtReasonAccess_7' name='txtReasonAccess_7' className='add-only' /> </td>
                        <td className='w-200'> <input type='text' id='txtPersonAccessing_7' name='txtPersonAccessing_7' className='add-only' /> </td>
                        <td className='w-187'> <input type='text' id='txtTitle_7' name='txtTitle_7' className='add-only' /> </td>
                    </tr>
                    <tr>
                        <td className='w-150'> <input type='date' id='dtDate_8' name='dtDate_8' className='add-only' /> </td>
                        <td className='w-187'> <input type='text' id='txtReasonAccess_8' name='txtReasonAccess_8' className='add-only' /> </td>
                        <td className='w-200'> <input type='text' id='txtPersonAccessing_8' name='txtPersonAccessing_8' className='add-only' /> </td>
                        <td className='w-187'> <input type='text' id='txtTitle_8' name='txtTitle_8' className='add-only' /> </td>
                    </tr>
                    <tr>
                        <td className='w-150'> <input type='date' id='dtDate_9' name='dtDate_9' className='add-only' /> </td>
                        <td className='w-187'> <input type='text' id='txtReasonAccess_9' name='txtReasonAccess_9' className='add-only' /> </td>
                        <td className='w-200'> <input type='text' id='txtPersonAccessing_9' name='txtPersonAccessing_9' className='add-only' /> </td>
                        <td className='w-187'> <input type='text' id='txtTitle_9' name='txtTitle_9' className='add-only' /> </td>
                    </tr>
                    <tr>
                        <td className='w-150'> <input type='date' id='dtDate_10' name='dtDate_10' className='add-only' /> </td>
                        <td className='w-187'> <input type='text' id='txtReasonAccess_10' name='txtReasonAccess_10' className='add-only' /> </td>
                        <td className='w-200'> <input type='text' id='txtPersonAccessing_10' name='txtPersonAccessing_10' className='add-only' /> </td>
                        <td className='w-187'> <input type='text' id='txtTitle_10' name='txtTitle_10' className='add-only' /> </td>
                    </tr>
                    <tr>
                        <td className='w-150'> <input type='date' id='dtDate_11' name='dtDate_11' className='add-only' /> </td>
                        <td className='w-187'> <input type='text' id='txtReasonAccess_11' name='txtReasonAccess_11' className='add-only' /> </td>
                        <td className='w-200'> <input type='text' id='txtPersonAccessing_11' name='txtPersonAccessing_11' className='add-only' /> </td>
                        <td className='w-187'> <input type='text' id='txtTitle_11' name='txtTitle_11' className='add-only' /> </td>
                    </tr>
                    <tr>
                        <td className='w-150'> <input type='date' id='dtDate_12' name='dtDate_12' className='add-only' /> </td>
                        <td className='w-187'> <input type='text' id='txtReasonAccess_12' name='txtReasonAccess_12' className='add-only' /> </td>
                        <td className='w-200'> <input type='text' id='txtPersonAccessing_12' name='txtPersonAccessing_12' className='add-only' /> </td>
                        <td className='w-187'> <input type='text' id='txtTitle_12' name='txtTitle_12' className='add-only' /> </td>
                    </tr>
                    <tr>
                        <td className='w-150'> <input type='date' id='dtDate_13' name='dtDate_13' className='add-only' /> </td>
                        <td className='w-187'> <input type='text' id='txtReasonAccess_13' name='txtReasonAccess_13' className='add-only' /> </td>
                        <td className='w-200'> <input type='text' id='txtPersonAccessing_13' name='txtPersonAccessing_13' className='add-only' /> </td>
                        <td className='w-187'> <input type='text' id='txtTitle_13' name='txtTitle_13' className='add-only' /> </td>
                    </tr>
                    <tr>
                        <td className='w-150'> <input type='date' id='dtDate_14' name='dtDate_14' className='add-only' /> </td>
                        <td className='w-187'> <input type='text' id='txtReasonAccess_14' name='txtReasonAccess_14' className='add-only' /> </td>
                        <td className='w-200'> <input type='text' id='txtPersonAccessing_14' name='txtPersonAccessing_14' className='add-only' /> </td>
                        <td className='w-187'> <input type='text' id='txtTitle_14' name='txtTitle_14' className='add-only' /> </td>
                    </tr>
                    <tr>
                        <td className='w-150'> <input type='date' id='dtDate_15' name='dtDate_15' className='add-only' /> </td>
                        <td className='w-187'> <input type='text' id='txtReasonAccess_15' name='txtReasonAccess_15' className='add-only' /> </td>
                        <td className='w-200'> <input type='text' id='txtPersonAccessing_15' name='txtPersonAccessing_15' className='add-only' /> </td>
                        <td className='w-187'> <input type='text' id='txtTitle_15' name='txtTitle_15' className='add-only' /> </td>
                    </tr>
                    <tr>
                        <td className='w-150'> <input type='date' id='dtDate_16' name='dtDate_16' className='add-only' /> </td>
                        <td className='w-187'> <input type='text' id='txtReasonAccess_16' name='txtReasonAccess_16' className='add-only' /> </td>
                        <td className='w-200'> <input type='text' id='txtPersonAccessing_16' name='txtPersonAccessing_16' className='add-only' /> </td>
                        <td className='w-187'> <input type='text' id='txtTitle_16' name='txtTitle_16' className='add-only' /> </td>
                    </tr>
                    <tr>
                        <td className='w-150'> <input type='date' id='dtDate_17' name='dtDate_17' className='add-only' /> </td>
                        <td className='w-187'> <input type='text' id='txtReasonAccess_17' name='txtReasonAccess_17' className='add-only' /> </td>
                        <td className='w-200'> <input type='text' id='txtPersonAccessing_17' name='txtPersonAccessing_17' className='add-only' /> </td>
                        <td className='w-187'> <input type='text' id='txtTitle_17' name='txtTitle_17' className='add-only' /> </td>
                    </tr>
                    <tr>
                        <td className='w-150'> <input type='date' id='dtDate_18' name='dtDate_18' className='add-only' /> </td>
                        <td className='w-187'> <input type='text' id='txtReasonAccess_18' name='txtReasonAccess_18' className='add-only' /> </td>
                        <td className='w-200'> <input type='text' id='txtPersonAccessing_18' name='txtPersonAccessing_18' className='add-only' /> </td>
                        <td className='w-187'> <input type='text' id='txtTitle_18' name='txtTitle_18' className='add-only' /> </td>
                    </tr>
                    <tr>
                        <td className='w-150'> <input type='date' id='dtDate_19' name='dtDate_19' className='add-only' /> </td>
                        <td className='w-187'> <input type='text' id='txtReasonAccess_19' name='txtReasonAccess_19' className='add-only' /> </td>
                        <td className='w-200'> <input type='text' id='txtPersonAccessing_19' name='txtPersonAccessing_19' className='add-only' /> </td>
                        <td className='w-187'> <input type='text' id='txtTitle_19' name='txtTitle_19' className='add-only' /> </td>
                    </tr>
                    <tr>
                        <td className='w-150'> <input type='date' id='dtDate_20' name='dtDate_20' className='add-only' /> </td>
                        <td className='w-187'> <input type='text' id='txtReasonAccess_20' name='txtReasonAccess_20' className='add-only' /> </td>
                        <td className='w-200'> <input type='text' id='txtPersonAccessing_20' name='txtPersonAccessing_20' className='add-only' /> </td>
                        <td className='w-187'> <input type='text' id='txtTitle_20' name='txtTitle_20' className='add-only' /> </td>
                    </tr>
                    <tr>
                        <td className='w-150'> <input type='date' id='dtDate_21' name='dtDate_21' className='add-only' /> </td>
                        <td className='w-187'> <input type='text' id='txtReasonAccess_21' name='txtReasonAccess_21' className='add-only' /> </td>
                        <td className='w-200'> <input type='text' id='txtPersonAccessing_21' name='txtPersonAccessing_21' className='add-only' /> </td>
                        <td className='w-187'> <input type='text' id='txtTitle_21' name='txtTitle_21' className='add-only' /> </td>
                    </tr>
                    <tr>
                        <td className='w-150'> <input type='date' id='dtDate_22' name='dtDate_22' className='add-only' /> </td>
                        <td className='w-187'> <input type='text' id='txtReasonAccess_22' name='txtReasonAccess_22' className='add-only' /> </td>
                        <td className='w-200'> <input type='text' id='txtPersonAccessing_22' name='txtPersonAccessing_22' className='add-only' /> </td>
                        <td className='w-187'> <input type='text' id='txtTitle_22' name='txtTitle_22' className='add-only' /> </td>
                    </tr>
                    <tr>
                        <td className='w-150'> <input type='date' id='dtDate_23' name='dtDate_23' className='add-only' /> </td>
                        <td className='w-187'> <input type='text' id='txtReasonAccess_23' name='txtReasonAccess_23' className='add-only' /> </td>
                        <td className='w-200'> <input type='text' id='txtPersonAccessing_23' name='txtPersonAccessing_23' className='add-only' /> </td>
                        <td className='w-187'> <input type='text' id='txtTitle_23' name='txtTitle_23' className='add-only' /> </td>
                    </tr>
                    <tr>
                        <td className='w-150'> <input type='date' id='dtDate_24' name='dtDate_24' className='add-only' /> </td>
                        <td className='w-187'> <input type='text' id='txtReasonAccess_24' name='txtReasonAccess_24' className='add-only' /> </td>
                        <td className='w-200'> <input type='text' id='txtPersonAccessing_24' name='txtPersonAccessing_24' className='add-only' /> </td>
                        <td className='w-187'> <input type='text' id='txtTitle_24' name='txtTitle_24' className='add-only' /> </td>
                    </tr>
                    <tr>
                        <td className='w-150'> <input type='date' id='dtDate_25' name='dtDate_25' className='add-only' /> </td>
                        <td className='w-187'> <input type='text' id='txtReasonAccess_25' name='txtReasonAccess_25' className='add-only' /> </td>
                        <td className='w-200'> <input type='text' id='txtPersonAccessing_25' name='txtPersonAccessing_25' className='add-only' /> </td>
                        <td className='w-187'> <input type='text' id='txtTitle_25' name='txtTitle_25' className='add-only' /> </td>
                    </tr>
                </table>
                <h3>RECORD OF ACCESS</h3>
                <table>
                <tr>
                        <td className='w-150'> <span className='eleHeader'>DATE</span> </td>
                        <td className='w-187'> <span className='eleHeader'>Blood Pressure</span> </td>
                        <td className='w-200'> <span className='eleHeader'>Pulse</span> </td>
                        <td className='w-187'> <span className='eleHeader'>Weight </span> </td>
                    </tr>
                    <tr>
                        <td className='w-150'> <input type='date' id='dtDatePg_2_1' name='dtDatePg_2_1' className='add-only' /> </td>
                        <td className='w-187'> <input type='text' id='txtBloodPressure_1' name='txtBloodPressure_1' className='add-only' /> </td>
                        <td className='w-200'> <input type='text' id='txtPulse_1' name='txtPulse_1' className='add-only' /> </td>
                        <td className='w-187'> <input type='text' id='txtWeight_1' name='txtWeight_1' className='add-only' /> </td>
                    </tr>
                    <tr>
                        <td className='w-150'> <input type='date' id='dtDatePg_2_2' name='dtDatePg_2_2' className='add-only' /> </td>
                        <td className='w-187'> <input type='text' id='txtBloodPressure_2' name='txtBloodPressure_2' className='add-only' /> </td>
                        <td className='w-200'> <input type='text' id='txtPulse_2' name='txtPulse_2' className='add-only' /> </td>
                        <td className='w-187'> <input type='text' id='txtWeight_2' name='txtWeight_2' className='add-only' /> </td>
                    </tr>
                    <tr>
                        <td className='w-150'> <input type='date' id='dtDatePg_2_3' name='dtDatePg_2_3' className='add-only' /> </td>
                        <td className='w-187'> <input type='text' id='txtBloodPressure_3' name='txtBloodPressure_3' className='add-only' /> </td>
                        <td className='w-200'> <input type='text' id='txtPulse_3' name='txtPulse_3' className='add-only' /> </td>
                        <td className='w-187'> <input type='text' id='txtWeight_3' name='txtWeight_3' className='add-only' /> </td>
                    </tr>
                    <tr>
                        <td className='w-150'> <input type='date' id='dtDatePg_2_4' name='dtDatePg_2_4' className='add-only' /> </td>
                        <td className='w-187'> <input type='text' id='txtBloodPressure_4' name='txtBloodPressure_4' className='add-only' /> </td>
                        <td className='w-200'> <input type='text' id='txtPulse_4' name='txtPulse_4' className='add-only' /> </td>
                        <td className='w-187'> <input type='text' id='txtWeight_4' name='txtWeight_4' className='add-only' /> </td>
                    </tr>
                    <tr>
                        <td className='w-150'> <input type='date' id='dtDatePg_2_5' name='dtDatePg_2_5' className='add-only' /> </td>
                        <td className='w-187'> <input type='text' id='txtBloodPressure_5' name='txtBloodPressure_5' className='add-only' /> </td>
                        <td className='w-200'> <input type='text' id='txtPulse_5' name='txtPulse_5' className='add-only' /> </td>
                        <td className='w-187'> <input type='text' id='txtWeight_5' name='txtWeight_5' className='add-only' /> </td>
                    </tr>
                    <tr>
                        <td className='w-150'> <input type='date' id='dtDatePg_2_6' name='dtDatePg_2_6' className='add-only' /> </td>
                        <td className='w-187'> <input type='text' id='txtBloodPressure_6' name='txtBloodPressure_6' className='add-only' /> </td>
                        <td className='w-200'> <input type='text' id='txtPulse_6' name='txtPulse_6' className='add-only' /> </td>
                        <td className='w-187'> <input type='text' id='txtWeight_6' name='txtWeight_6' className='add-only' /> </td>
                    </tr>
                    <tr>
                        <td className='w-150'> <input type='date' id='dtDatePg_2_7' name='dtDatePg_2_7' className='add-only' /> </td>
                        <td className='w-187'> <input type='text' id='txtBloodPressure_7' name='txtBloodPressure_7' className='add-only' /> </td>
                        <td className='w-200'> <input type='text' id='txtPulse_7' name='txtPulse_7' className='add-only' /> </td>
                        <td className='w-187'> <input type='text' id='txtWeight_7' name='txtWeight_7' className='add-only' /> </td>
                    </tr>
                    <tr>
                        <td className='w-150'> <input type='date' id='dtDatePg_2_8' name='dtDatePg_2_8' className='add-only' /> </td>
                        <td className='w-187'> <input type='text' id='txtBloodPressure_8' name='txtBloodPressure_8' className='add-only' /> </td>
                        <td className='w-200'> <input type='text' id='txtPulse_8' name='txtPulse_8' className='add-only' /> </td>
                        <td className='w-187'> <input type='text' id='txtWeight_8' name='txtWeight_8' className='add-only' /> </td>
                    </tr>
                    <tr>
                        <td className='w-150'> <input type='date' id='dtDatePg_2_9' name='dtDatePg_2_9' className='add-only' /> </td>
                        <td className='w-187'> <input type='text' id='txtBloodPressure_9' name='txtBloodPressure_9' className='add-only' /> </td>
                        <td className='w-200'> <input type='text' id='txtPulse_9' name='txtPulse_9' className='add-only' /> </td>
                        <td className='w-187'> <input type='text' id='txtWeight_9' name='txtWeight_9' className='add-only' /> </td>
                    </tr>
                    <tr>
                        <td className='w-150'> <input type='date' id='dtDatePg_2_10' name='dtDatePg_2_10' className='add-only' /> </td>
                        <td className='w-187'> <input type='text' id='txtBloodPressure_10' name='txtBloodPressure_10' className='add-only' /> </td>
                        <td className='w-200'> <input type='text' id='txtPulse_10' name='txtPulse_10' className='add-only' /> </td>
                        <td className='w-187'> <input type='text' id='txtWeight_10' name='txtWeight_10' className='add-only' /> </td>
                    </tr>
                    <tr>
                        <td className='w-150'> <input type='date' id='dtDatePg_2_11' name='dtDatePg_2_11' className='add-only' /> </td>
                        <td className='w-187'> <input type='text' id='txtBloodPressure_11' name='txtBloodPressure_11' className='add-only' /> </td>
                        <td className='w-200'> <input type='text' id='txtPulse_11' name='txtPulse_11' className='add-only' /> </td>
                        <td className='w-187'> <input type='text' id='txtWeight_11' name='txtWeight_11' className='add-only' /> </td>
                    </tr>
                    <tr>
                        <td className='w-150'> <input type='date' id='dtDatePg_2_12' name='dtDatePg_2_12' className='add-only' /> </td>
                        <td className='w-187'> <input type='text' id='txtBloodPressure_12' name='txtBloodPressure_12' className='add-only' /> </td>
                        <td className='w-200'> <input type='text' id='txtPulse_12' name='txtPulse_12' className='add-only' /> </td>
                        <td className='w-187'> <input type='text' id='txtWeight_12' name='txtWeight_12' className='add-only' /> </td>
                    </tr>
                    <tr>
                        <td className='w-150'> <input type='date' id='dtDatePg_2_13' name='dtDatePg_2_13' className='add-only' /> </td>
                        <td className='w-187'> <input type='text' id='txtBloodPressure_13' name='txtBloodPressure_13' className='add-only' /> </td>
                        <td className='w-200'> <input type='text' id='txtPulse_13' name='txtPulse_13' className='add-only' /> </td>
                        <td className='w-187'> <input type='text' id='txtWeight_13' name='txtWeight_13' className='add-only' /> </td>
                    </tr>
                    <tr>
                        <td className='w-150'> <input type='date' id='dtDatePg_2_14' name='dtDatePg_2_14' className='add-only' /> </td>
                        <td className='w-187'> <input type='text' id='txtBloodPressure_14' name='txtBloodPressure_14' className='add-only' /> </td>
                        <td className='w-200'> <input type='text' id='txtPulse_14' name='txtPulse_14' className='add-only' /> </td>
                        <td className='w-187'> <input type='text' id='txtWeight_14' name='txtWeight_14' className='add-only' /> </td>
                    </tr>
                    <tr>
                        <td className='w-150'> <input type='date' id='dtDatePg_2_15' name='dtDatePg_2_15' className='add-only' /> </td>
                        <td className='w-187'> <input type='text' id='txtBloodPressure_15' name='txtBloodPressure_15' className='add-only' /> </td>
                        <td className='w-200'> <input type='text' id='txtPulse_15' name='txtPulse_15' className='add-only' /> </td>
                        <td className='w-187'> <input type='text' id='txtWeight_15' name='txtWeight_15' className='add-only' /> </td>
                    </tr>
                    <tr>
                        <td className='w-150'> <input type='date' id='dtDatePg_2_16' name='dtDatePg_2_16' className='add-only' /> </td>
                        <td className='w-187'> <input type='text' id='txtBloodPressure_16' name='txtBloodPressure_16' className='add-only' /> </td>
                        <td className='w-200'> <input type='text' id='txtPulse_16' name='txtPulse_16' className='add-only' /> </td>
                        <td className='w-187'> <input type='text' id='txtWeight_16' name='txtWeight_16' className='add-only' /> </td>
                    </tr>
                    <tr>
                        <td className='w-150'> <input type='date' id='dtDatePg_2_17' name='dtDatePg_2_17' className='add-only' /> </td>
                        <td className='w-187'> <input type='text' id='txtBloodPressure_17' name='txtBloodPressure_17' className='add-only' /> </td>
                        <td className='w-200'> <input type='text' id='txtPulse_17' name='txtPulse_17' className='add-only' /> </td>
                        <td className='w-187'> <input type='text' id='txtWeight_17' name='txtWeight_17' className='add-only' /> </td>
                    </tr>
                    <tr>
                        <td className='w-150'> <input type='date' id='dtDatePg_2_18' name='dtDatePg_2_18' className='add-only' /> </td>
                        <td className='w-187'> <input type='text' id='txtBloodPressure_18' name='txtBloodPressure_18' className='add-only' /> </td>
                        <td className='w-200'> <input type='text' id='txtPulse_18' name='txtPulse_18' className='add-only' /> </td>
                        <td className='w-187'> <input type='text' id='txtWeight_18' name='txtWeight_18' className='add-only' /> </td>
                    </tr>
                    <tr>
                        <td className='w-150'> <input type='date' id='dtDatePg_2_19' name='dtDatePg_2_19' className='add-only' /> </td>
                        <td className='w-187'> <input type='text' id='txtBloodPressure_19' name='txtBloodPressure_19' className='add-only' /> </td>
                        <td className='w-200'> <input type='text' id='txtPulse_19' name='txtPulse_19' className='add-only' /> </td>
                        <td className='w-187'> <input type='text' id='txtWeight_19' name='txtWeight_19' className='add-only' /> </td>
                    </tr>
                    <tr>
                        <td className='w-150'> <input type='date' id='dtDatePg_2_20' name='dtDatePg_2_20' className='add-only' /> </td>
                        <td className='w-187'> <input type='text' id='txtBloodPressure_20' name='txtBloodPressure_20' className='add-only' /> </td>
                        <td className='w-200'> <input type='text' id='txtPulse_20' name='txtPulse_20' className='add-only' /> </td>
                        <td className='w-187'> <input type='text' id='txtWeight_20' name='txtWeight_20' className='add-only' /> </td>
                    </tr>
                    <tr>
                        <td className='w-150'> <input type='date' id='dtDatePg_2_21' name='dtDatePg_2_21' className='add-only' /> </td>
                        <td className='w-187'> <input type='text' id='txtBloodPressure_21' name='txtBloodPressure_21' className='add-only' /> </td>
                        <td className='w-200'> <input type='text' id='txtPulse_21' name='txtPulse_21' className='add-only' /> </td>
                        <td className='w-187'> <input type='text' id='txtWeight_21' name='txtWeight_21' className='add-only' /> </td>
                    </tr>
                    <tr>
                        <td className='w-150'> <input type='date' id='dtDatePg_2_22' name='dtDatePg_2_22' className='add-only' /> </td>
                        <td className='w-187'> <input type='text' id='txtBloodPressure_22' name='txtBloodPressure_22' className='add-only' /> </td>
                        <td className='w-200'> <input type='text' id='txtPulse_22' name='txtPulse_22' className='add-only' /> </td>
                        <td className='w-187'> <input type='text' id='txtWeight_22' name='txtWeight_22' className='add-only' /> </td>
                    </tr>
                    <tr>
                        <td className='w-150'> <input type='date' id='dtDatePg_2_23' name='dtDatePg_2_23' className='add-only' /> </td>
                        <td className='w-187'> <input type='text' id='txtBloodPressure_23' name='txtBloodPressure_23' className='add-only' /> </td>
                        <td className='w-200'> <input type='text' id='txtPulse_23' name='txtPulse_23' className='add-only' /> </td>
                        <td className='w-187'> <input type='text' id='txtWeight_23' name='txtWeight_23' className='add-only' /> </td>
                    </tr>
                    <tr>
                        <td className='w-150'> <input type='date' id='dtDatePg_2_24' name='dtDatePg_2_24' className='add-only' /> </td>
                        <td className='w-187'> <input type='text' id='txtBloodPressure_24' name='txtBloodPressure_24' className='add-only' /> </td>
                        <td className='w-200'> <input type='text' id='txtPulse_24' name='txtPulse_24' className='add-only' /> </td>
                        <td className='w-187'> <input type='text' id='txtWeight_24' name='txtWeight_24' className='add-only' /> </td>
                    </tr>
                    <tr>
                        <td className='w-150'> <input type='date' id='dtDatePg_2_25' name='dtDatePg_2_25' className='add-only' /> </td>
                        <td className='w-187'> <input type='text' id='txtBloodPressure_25' name='txtBloodPressure_25' className='add-only' /> </td>
                        <td className='w-200'> <input type='text' id='txtPulse_25' name='txtPulse_25' className='add-only' /> </td>
                        <td className='w-187'> <input type='text' id='txtWeight_25' name='txtWeight_25' className='add-only' /> </td>
                    </tr>
            </table>
            <h3>New Client Checklist</h3>
            <p className='w-750'>
                    <span className='eleHeader'>Enrollment PacketCompletion Date:</span>
                    <input type='date' id='dtPacketCompletionDate' name='dtPacketCompletionDate' className='add-only' />
            </p>
            <ol>
                <li>Intake packet</li>
                 <ol type='a'>
                   <li>Signed by client / legally responsible</li>
                   <li> Signed by LEIBS representative</li>
                   <li>Medicaid eligibility printout / Medicaid card</li>
                </ol>
                    <li>CMBHS Diagnosis Sheet</li>
                    <li>CMBHS ANSA assessment printed and signed</li>
                    <li>OTR</li>
                    <li>Treatment Plan</li>
                     <ol type='a'>
                        <li>Signed by LPHA</li>
                        <li>Signed by case worker</li>
                        <li> Signed by client/ Legally Responsible Person</li>
                     </ol>
                    <li>Mental Health Assessment</li>
                      <ol type='a'>
                        <li>Signed by LPHA</li>
                      </ol>
                    <li>Forms to upload to client's profile:</li>
                     <ol type='a'>
                        <li>CMBHS diagnosis Sheet</li>
                        <li>CMBHS ANSA (closed and complete status)</li>
                        <li>OTR</li>
                        <li>Treatment Plan</li>
                        <li>Mental Health Assessment</li>
                     </ol>
                    <li>Sharenote</li>
                    <ol type='a'>
                        <li>Assign Case Worker</li>
                        <li>Assign Services based on LOC</li>
                        <li>Confirm Treatment Plan is signed</li>
                        <li>Add PA units</li>
                    </ol>
            </ol>
            <h3>FOLLOW UP CALL:</h3>
            <table>
                <tr>
                   <td className='w-375'> <span className='eleHeader'>Date of call:</span> </td>
                   <td className='w-375'> <span className='eleHeader'>Contact Person:</span> </td> 
                </tr>
                <tr>
                   <td className='w-375'> <input type='date' id='dtDateOfCall' name='dtDateOfCall' className='add-only' /> </td>
                   <td className='w-375'> <input type='text' id='txtContactPerson' name='txtContactPerson' className='add-only' /> </td>
                </tr>
                <tr>
                   <td className='w-375'> <span className='eleHeader'>Staff Name:</span> <input type='text' id='txtStaffName_1' name='txtStaffName_1' className='add-only' /></td>
                   <td className='w-375'> <span className='eleHeader'>Staff Name:</span> <input type='text' id='txtStaffName_2' name='txtStaffName_2' className='add-only' /></td>
                </tr>
            </table>
            <p className='w-750'>
                    <span className='eleHeader'>COMMENTS: </span>
                    <textarea id="txtComments" name="txtComments" className='add-only'></textarea>
            </p>
            <table>
                <tr>
                   <td className='w-375'> <span className='eleHeader'>Assigned Case Worker: </span> </td>
                   <td className='w-375'> <span className='eleHeader'>Date Assigned:</span> </td> 
                </tr>
                <tr>
                   <td className='w-375'> <input type='text' id='txtAssignedCaseWorker' name='txtAssignedCaseWorker' className='add-only' /> </td>
                   <td className='w-375'> <input type='date' id='dtDateAssigned' name='dtDateAssigned' className='add-only' /> </td>
                </tr>
                <tr>
                   <td className='w-375'> <span className='eleHeader'>Client Enrollment Completed by: </span> </td>
                   <td className='w-375'> <span className='eleHeader'>Date:</span> </td> 
                </tr>
                <tr>
                   <td className='w-375'> <input type='text' id='txtClientEnrollmentCompleted' name='txtClientEnrollmentCompleted' className='add-only' /> </td>
                   <td className='w-375'> <input type='date' id='dtFollowUpCallDate' name='dtFollowUpCallDate' className='add-only' /> </td>
                </tr>
            </table>
            <h3>INTAKE FACE SHEET</h3>
            <table>
                <tr>
                   <td className='w-375'> <span className='eleHeader'>Date:</span> </td>
                   <td className='w-375'> <span className='eleHeader'>How did you hear about us:</span> </td> 
                </tr>
                <tr>
                   <td className='w-375'> <input type='date' id='dtFaceSheetDate' name='dtFaceSheetDate' className='add-only' /> </td>
                   <td className='w-375'> <input type='text' id='txtaboutUs' name='txtaboutUs' className='add-only' /> </td>
                </tr>
                <tr>
                   <td className='w-250'> <span className='eleHeader'>Name:</span> </td>
                   <td className='w-250'> <span className='eleHeader'>Date of Birth</span> </td> 
                   <td className='w-250'> <span className='eleHeader'>Age</span> </td> 
                </tr>
                <tr>
                   <td className='w-250'> <input type='text' id='txtName' name='txtName' className='add-only' /> </td>
                   <td className='w-250'> <input type='date' id='dtdob' name='dtdob' className='add-only' /> </td>
                   <td className='w-250'> <input type='text' id='txtAge' name='txtaboutUs' className='add-only' /> </td>
                </tr>
                <tr>
                   <td className='w-250'> <span className='eleHeader'>Height:</span> </td>
                   <td className='w-250'> <span className='eleHeader'>Weight:</span> </td> 
                   <td className='w-250'> <span className='eleHeader'>Eye Color:</span> </td> 
                </tr>
                <tr>
                   <td className='w-250'> <input type='text' id='txtHeight' name='txtHeight' className='add-only' /> </td>
                   <td className='w-250'> <input type='text' id='txtWeight' name='txtWeight' className='add-only' /> </td>
                   <td className='w-250'> <input type='text' id='txtEyeColor' name='txtEyeColor' className='add-only' /> </td>
                </tr>
                <tr>
                   <td className='w-375'> <span className='eleHeader'>Insurance Company #</span> </td>
                   <td className='w-375'> <span className='eleHeader'>Medicaid #</span> </td> 
                </tr>
                <tr>
                   <td className='w-375'> <input type='text' id='txtInsuranceCompany' name='txtInsuranceCompany' className='add-only' /> </td>
                   <td className='w-375'> <input type='text' id='txtMedicaid' name='txtMedicaid' className='add-only' /> </td>
                </tr>
                <tr>
                   <td className='w-375'> <span className='eleHeader'>Address</span> </td>
                   <td className='w-375'> <span className='eleHeader'>City/State/Zip</span> </td> 
                </tr>
                <tr>
                   <td className='w-375'> <input type='text' id='txtAddress' name='txtAddress' className='add-only' /> </td>
                   <td className='w-375'> <input type='text' id='txtCity_State_Zip' name='txtCity_State_Zip' className='add-only' /> </td>
                </tr>
                <tr>
                   <td className='w-250'> <span className='eleHeader'>Home #</span> </td>
                   <td className='w-250'> <span className='eleHeader'>Cell Phone #</span> </td> 
                   <td className='w-250'> <span className='eleHeader'>Work#</span> </td> 
                </tr>
                <tr>
                   <td className='w-250'> <input type='text' id='txtHome' name='txtHome' className='add-only' /> </td>
                   <td className='w-250'> <input type='text' id='txtCellPhone' name='txtCellPhone' className='add-only' /> </td>
                   <td className='w-250'> <input type='text' id='txtWork' name='txtWork' className='add-only' /> </td>
                </tr>
            </table>
            <table>
                    <tr>
                        <td className="w-750">
                            <span className="eleHeader">Employment Status:</span>
                        </td>
                    </tr>
                    <tr>
                        <td className="w-150">
                            <input type="radio" id="rb_partTime" name="rb_EmploymentStatus" className="add-only" value="1" /> Part-time 
                        </td>
                        <td className="w-150">
                            <input type="radio" id="rb_fullTime" name="rb_EmploymentStatus" className="add-only" value="2" /> Full-time
                        </td>
                        <td className="w-150">
                            <input type="radio" id="rb_Retired" name="rb_EmploymentStatus" className="add-only" value="3" /> Retired 
                        </td>
                        <td className="w-150">
                            <input type="radio" id="rb_Unemployed" name="rb_EmploymentStatus" className="add-only" value="4" /> Unemployed
                        </td>
                        <td className="w-150">
                            <input type="radio" id="rb_NotLaborForce" name="rb_EmploymentStatus" className="add-only" value="5" /> Not in labor force
                        </td>
                    </tr>
            </table>
            <p className='w-750'>
                    <span className='eleHeader'>Employer:</span>
                    <input type='text' id='txtEmployer' name='txtEmployer' className='add-only' />
            </p>
            <table>
                    <tr>
                        <td className="w-750">
                            <span className="eleHeader">Marital Status: </span>
                        </td>
                    </tr>
                    <tr>
                        <td className="w-150">
                            <input type="radio" id="rb_MaritalStatus_1" name="rb_MaritalStatus" className="add-only" value="1" /> 1.Single
                        </td>
                        <td className="w-150">
                            <input type="radio" id="rb_MaritalStatus_2" name="rb_MaritalStatus" className="add-only" value="2" /> 2. Married
                        </td>
                    </tr>
            </table>
            <table>
                    <tr>
                        <td className="w-750">
                            <span className="eleHeader">Gender: </span>
                        </td>
                    </tr>
                    <tr>
                        <td className="w-150">
                            <input type="radio" id="rb_male" name="rb_Gender" className="add-only" value="1" /> 1.Male 
                        </td>
                        <td className="w-150">
                            <input type="radio" id="rb_female" name="rb_Gender" className="add-only" value="2" /> 2.Female
                        </td>
                    </tr>
            </table>
            <table>
                    <tr>
                        <td className="w-750">
                            <span className="eleHeader">Student Status:</span>
                        </td>
                    </tr>
                    <tr>
                        <td className="w-250">
                            <input type="radio" id="rb_StudentStatus_1" name="rb_StudentStatus" className="add-only" value="1" /> 1.Full Time Student 
                        </td>
                        <td className="w-250">
                            <input type="radio" id="rb_StudentStatus_2" name="rb_StudentStatus" className="add-only" value="2" /> 2.Part-time Student 
                        </td>
                        <td className="w-250">
                            <input type="radio" id="rb_StudentStatus_3" name="rb_StudentStatus" className="add-only" value="3" /> 3.Not a student 
                        </td>
                    </tr>
            </table>
            <table>
                <tr>
                   <td className='w-375'> <span className='eleHeader'>School</span> </td>
                   <td className='w-375'> <span className='eleHeader'>Last Grade Completed:</span> </td> 
                </tr>
                <tr>
                   <td className='w-375'> <input type='text' id='txtSchool' name='txtSchool' className='add-only' /> </td>
                   <td className='w-375'> <input type='text' id='txtLastGrade' name='txtLastGrade' className='add-only' /> </td>
                </tr>
            </table>
            <table>
                    <tr>
                        <td className="w-750">
                            <span className="eleHeader">Race:</span>
                        </td>
                    </tr>
                    <tr>
                        <td className="w-250">
                            <input type="radio" id="rb_Race_1" name="rb_Race" className="add-only" value="1" /> White
                        </td>
                        <td className="w-250">
                            <input type="radio" id="rb_Race_2" name="rb_Race" className="add-only" value="2" /> Black or African American 
                        </td>
                        <td className="w-250">
                            <input type="radio" id="rb_Race_3" name="rb_Race" className="add-only" value="3" /> Hispanic
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <input type="radio" id="rb_Race_4" name="rb_Race" className='add-only' value="4" /> Other:
                            <input type="text" id="txt_Race_4" name="txt_Race_4" className='add-only' /> 
                                                                                             
                        </td>
                    </tr>
            </table>
            <table>
                <tr>
                   <td className='w-750'> <span className='eleHeader'>Preferred Language:</span> </td>
                </tr>
                <tr>
                   <td className='w-750'> <input type='text' id='txtPreferredLanguage' name='txtPreferredLanguage' className='add-only' /> </td>
                </tr>
            </table>
            <table>
                    <tr>
                        <td className="w-750">
                            <span className="eleHeader">Need Interpreter:</span>
                        </td>
                    </tr>
                    <tr>
                        <td className="w-150">
                            <input type="radio" id="rb_NeedInterpreter_1" name="rb_NeedInterpreter" className="add-only" value="1" /> Yes
                        </td>
                        <td className="w-150">
                            <input type="radio" id="rb_NeedInterpreter_2" name="rb_NeedInterpreter" className="add-only" value="2" /> No
                        </td>
                    </tr>
            </table>
            <table>
                    <tr>
                        <td className="w-750">
                            <span className="eleHeader">Have you previously received or currently receiving mental health services? </span>
                        </td>
                    </tr>
                    <tr>
                        <td className="w-150">
                            <input type="radio" id="rb_mentalHealthServices_1" name="rb_mentalHealthServices" className="add-only" value="1" /> Yes
                        </td>
                        <td className="w-150">
                            <input type="radio" id="rb_mentalHealthServices_2" name="rb_mentalHealthServices" className="add-only" value="2" /> No
                        </td>
                    </tr>
            </table>
            <b>If yes,</b>
            <p className='w-750'>
                    <span className='eleHeader'>please list:</span>
                    <textarea id="txtpleaselist" name="txtpleaselist" className='add-only'></textarea>
            </p>
            <table>
                <tr>
                   <td className='w-250'> <span className='eleHeader'>Primary Physician Name:</span> </td>
                   <td className='w-250'> <span className='eleHeader'>Phone #:</span> </td> 
                   <td className='w-250'> <span className='eleHeader'>Last seen:</span> </td> 
                </tr>
                <tr>
                   <td className='w-250'> <input type='text' id='txtPrimaryPhysicianName' name='txtPrimaryPhysicianName' className='add-only' /> </td> 
                   <td className='w-250'> <input type='text' id='txtPhone' name='txtPhone' className='add-only' /> </td>
                   <td className='w-250'> <input type='text' id='txtLastseen' name='txtLastseen' className='add-only' /> </td>
                </tr>
            </table>
            <p className='w-750'>
                    <span className='eleHeader'>Referred By</span>
                    <input type='text' id='txtReferred' name='txtReferred' className='add-only' />
            </p>
            <p className='w-750'>
                    <span className='eleHeader'>Reason for referral:</span>
                    <input type='text' id='txtReasonReferral' name='txtReasonReferral' className='add-only' />
            </p>
            <table>
                <tr>
                   <td className='w-375'> <span className='eleHeader'>Legally Responsible Person</span> </td>
                   <td className='w-375'> <span className='eleHeader'>Relationship</span> </td> 
                </tr>
                <tr>
                   <td className='w-375'> <input type='text' id='txtResponsiblePerson' name='txtResponsiblePerson' className='add-only' /> </td>
                   <td className='w-375'> <input type='text' id='txtRelationship' name='txtRelationship' className='add-only' /> </td>
                </tr>
                <tr>
                   <td className='w-375'> <span className='eleHeader'>Address</span> </td>
                   <td className='w-375'> <span className='eleHeader'>City/State/Zip</span> </td> 
                </tr>
                <tr>
                   <td className='w-375'> <input type='text' id='txtAddress_1' name='txtAddress_1' className='add-only' /> </td>
                   <td className='w-375'> <input type='text' id='txtCity_State_Zip_1' name='txtCity_State_Zip_1' className='add-only' /> </td>
                </tr>
                <tr>
                   <td className='w-375'> <span className='eleHeader'>Phone #</span> </td> 
                   <td className='w-375'> <span className='eleHeader'>Work Phone #</span> </td> 
                </tr>
                <tr>
                   <td className='w-375'> <input type='text' id='txtPhone_1' name='txtPhone_1' className='add-only' /> </td>
                   <td className='w-375'> <input type='text' id='txtWorkPhone' name='txtWorkPhone' className='add-only' /> </td>
                </tr>
            </table>
            <table>
                    <tr>
                        <td className='w-750'><span className='eleHeader'>Emergency Contact Information</span></td>
                    </tr>
                    <tr>
                        <td className='signature w-250'>&nbsp; </td>
                        <td className='signature w-250'>&nbsp; </td>
                        <td className='signature w-250'>&nbsp; </td>
                    </tr>
                    <tr>
                        <td className='small w-250'>Name</td>
                        <td className='small w-250'>Relationship</td>
                        <td className='small w-250'>Phone#</td>
                    </tr>
                    <tr>
                        <td className='signature w-250'>&nbsp; </td>
                        <td className='signature w-250'>&nbsp; </td>
                        <td className='signature w-250'>&nbsp; </td>
                    </tr>
                    <tr>
                        <td className='small w-250'>Name</td>
                        <td className='small w-250'>Relationship</td>
                        <td className='small w-250'>Phone#</td>
                    </tr>
                </table>
                <h3>Client Data Form</h3>
                <table>
                    <tr>
                        <td className="w-750">
                            <span className="eleHeader">Presenting Problems(s)-</span>
                            <span className='small'>Please check all that apply</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'><input type='checkbox' id='cbPresentingProblems_1' name='cbPresentingProblems_1' className='add-only' value='Anxiety' />Anxiety</td>
                        <td className='w-250'><input type='checkbox' id='cbPresentingProblems_2' name='cbPresentingProblems_2' className='add-only' value='Fidgety' />Fidgety</td>
                        <td className='w-250'><input type='checkbox' id='cbPresentingProblems_3' name='cbPresentingProblems_3' className='add-only' value='Phobias' />Phobias</td>
                    </tr>
                    <tr>
                        <td className='w-250'><input type='checkbox' id='cbPresentingProblems_4' name='cbPresentingProblems_4' className='add-only' value='CriminalBehavior' />Criminal behavior (stealing, vandalism, etc.)</td>
                        <td className='w-250'><input type='checkbox' id='cbPresentingProblems_5' name='cbPresentingProblems_5' className='add-only' value='Fighting' />Fighting</td>
                        <td className='w-250'><input type='checkbox' id='cbPresentingProblems_6' name='cbPresentingProblems_6' className='add-only' value='Running away' />Running away</td>
                    </tr>
                    <tr>
                        <td className='w-250'><input type='checkbox' id='cbPresentingProblems_7' name='cbPresentingProblems_7' className='add-only' value='ConstantRestlessness' />Constant restlessness</td>
                        <td className='w-250'><input type='checkbox' id='cbPresentingProblems_8' name='cbPresentingProblems_8' className='add-only' value='Fire-setting' />Fire-setting</td>
                        <td className='w-250'><input type='checkbox' id='cbPresentingProblems_9' name='cbPresentingProblems_9' className='add-only' value='Suicidal' />Suicidal</td>
                    </tr>
                    <tr>
                        <td className='w-250'><input type='checkbox' id='cbPresentingProblems_10' name='cbPresentingProblems_10' className='add-only' value='Homicidal' />Homicidal</td>
                        <td className='w-250'><input type='checkbox' id='cbPresentingProblems_11' name='cbPresentingProblems_11' className='add-only' value='CuttingSelf' />Cutting self</td>
                        <td className='w-250'><input type='checkbox' id='cbPresentingProblems_12' name='cbPresentingProblems_12' className='add-only' value='Depression' />Depression</td>
                    </tr>
                    <tr>
                        <td className='w-250'><input type='checkbox' id='cbPresentingProblems_13' name='cbPresentingProblems_13' className='add-only' value='Forgetfulness' />Forgetfulness</td>
                        <td className='w-250'><input type='checkbox' id='cbPresentingProblems_14' name='cbPresentingProblems_14' className='add-only' value='Disrespectfulness' />Disrespectfulness</td>
                        <td className='w-250'><input type='checkbox' id='cbPresentingProblems_15' name='cbPresentingProblems_15' className='add-only' value='Lying' />Lying</td>
                    </tr>
                    <tr>
                        <td className='w-250'><input type='checkbox' id='cbPresentingProblems_16' name='cbPresentingProblems_16' className='add-only' value='Defiance_Oppositional' />Defiance/Oppositional</td>
                        <td className='w-250'><input type='checkbox' id='cbPresentingProblems_17' name='cbPresentingProblems_17' className='add-only' value='Self_Injurious_Behaviors' />Self-Injurious behaviors</td>
                        <td className='w-250'><input type='checkbox' id='cbPresentingProblems_18' name='cbPresentingProblems_18' className='add-only' value='Low-Self-esteem' />Low-Self-esteem</td>
                    </tr>
                    <tr>
                        <td className='w-250'><input type='checkbox' id='cbPresentingProblems_19' name='cbPresentingProblems_19' className='add-only' value='Destructiveness' />Destructiveness (destroying property)</td>
                        <td className='w-250'><input type='checkbox' id='cbPresentingProblems_20' name='cbPresentingProblems_20' className='add-only' value='Difficulty_concentrating' />Difficulty concentrating</td>
                        <td className='w-250'><input type='checkbox' id='cbPresentingProblems_21' name='cbPresentingProblems_21' className='add-only' value='Bullying' />Bullying</td>
                    </tr>
                    <tr>
                        <td className='w-250'><input type='checkbox' id='cbPresentingProblems_22' name='cbPresentingProblems_22' className='add-only' value='HurtingAnimals' />Hurting animals (pets)</td>
                        <td className='w-250'><input type='checkbox' id='cbPresentingProblems_23' name='cbPresentingProblems_23' className='add-only' value='Temper_Tantrums' />Temper tantrums</td>
                        <td className='w-250'><input type='checkbox' id='cbPresentingProblems_24' name='cbPresentingProblems_24' className='add-only' value='Hyperactive' />Hyperactive</td>
                    </tr>
                    <tr>
                        <td className='w-250'><input type='checkbox' id='cbPresentingProblems_25' name='cbPresentingProblems_25' className='add-only' value='ChangeAppetite' />Change in appetite</td>
                        <td className='w-250'><input type='checkbox' id='cbPresentingProblems_26' name='cbPresentingProblems_26' className='add-only' value='Withdrawal/lsolation' />Withdrawal/lsolation</td>
                        <td className='w-250'><input type='checkbox' id='cbPresentingProblems_27' name='cbPresentingProblems_27' className='add-only' value='Delusions' />Delusions</td>
                    </tr>
                    <tr>
                        <td className='w-250'><input type='checkbox' id='cbPresentingProblems_28' name='cbPresentingProblems_28' className='add-only' value='Hallucinations' />Hallucinations (visual, auditory, etc. )</td>
                        <td className='w-250'><input type='checkbox' id='cbPresentingProblems_29' name='cbPresentingProblems_29' className='add-only' value='Excessive_energy' />Excessive energy</td>
                        <td className='w-250'><input type='checkbox' id='cbPresentingProblems_30' name='cbPresentingProblems_30' className='add-only' value='Excessive_Talking' />Excessive talking</td>
                    </tr>
                    <tr>
                        <td className='w-250'><input type='checkbox' id='cbPresentingProblems_31' name='cbPresentingProblems_31' className='add-only' value='ObsessionsCompulsions' />Obsessions/compulsions</td>
                        <td className='w-250'><input type='checkbox' id='cbPresentingProblems_32' name='cbPresentingProblems_32' className='add-only' value='Violent/aggressive_behaviors' />Violent/aggressive behaviors</td>
                        <td className='w-250'><input type='checkbox' id='cbPresentingProblems_33' name='cbPresentingProblems_33' className='add-only' value='Impulsiveness' />Impulsiveness</td>
                    </tr>
                    <tr>
                        <td className='w-250'><input type='checkbox' id='cbPresentingProblems_34' name='cbPresentingProblems_34' className='add-only' value='InsomniaHypersomnia' />Insomnia or Hypersomnia</td>
                        <td className='w-250'><input type='checkbox' id='cbPresentingProblems_35' name='cbPresentingProblems_35' className='add-only' value='Crying-Spells' />Crying Spells</td>
                        <td className='w-250'><input type='checkbox' id='cbPresentingProblems_35' name='cbPresentingProblems_35' className='add-only' value='Gravely_impaired' />Gravely impaired</td>
                    </tr>
                    <tr>
                        <td className='w-250'><input type='checkbox' id='cbPresentingProblems_36' name='cbPresentingProblems_36' className='add-only' value='ObsessionFirearms' />Obsession with firearms</td>
                    </tr>
            </table>
            <p className='w-750'>
                    <span className='eleHeader'>If suicidal, homicidal, gravely impaired or need further clinical guidance contact a licensed clinician to further assess for triage! Document clinical disposition when applicable.</span>
                    <textarea id="txtPresentingProblems" name="txtPresentingProblems" className='add-only'></textarea>
            </p>
            <h3>MEDICAL HISTORY QUESTIONAIRE</h3>
            <p className='w-750'>
                    <span className='eleHeader'>1. Are you taking any <b>medications</b> (prescription, over the counter vitamins, homeopathic or naturopathic remedies, traditional or alternative medicine remedies, herbs)?</span>
                    <textarea id="txtMedicalHistoryQuestionaire_1" name="txtMedicalHistoryQuestionaire_1" className='add-only'></textarea>
            </p>
            <h6 className='w-750'>2. Identify the medications that you are currently taking for medical or behavioral health concerns, and the reason for take the medications, below:</h6>
            <table>
                <tr>
                   <td className='w-190'> <span className='eleHeader'>Name of Medication</span> </td>
                   <td className='w-140'> <span className='eleHeader'>Dosage</span> </td>
                   <td className='w-140'> <span className='eleHeader'>Frequency</span> </td>
                   <td className='w-140'> <span className='eleHeader'>Duration</span> </td>
                   <td className='w-140'> <span className='eleHeader'>Prescriber</span> </td>  
                </tr>
                <tr>
                   <td className='w-190'> <input type='text' id='txtNameMedication_1' name='txtNameMedication_1' className='add-only' /> </td>
                   <td className='w-140'> <input type='text' id='txtDosage_1' name='txtDosage_1' className='add-only' /> </td>
                   <td className='w-140'> <input type='text' id='txtFrequency_1' name='txtFrequency_1' className='add-only' /> </td>
                   <td className='w-140'> <input type='text' id='txtDuration_1' name='txtDuration_1' className='add-only' /> </td>
                   <td className='w-140'> <input type='text' id='txtPrescriber_1' name='txtPrescriber_1' className='add-only' /> </td>
                </tr>
                <tr>
                   <td className='w-190'> <input type='text' id='txtNameMedication_2' name='txtNameMedication_2' className='add-only' /> </td>
                   <td className='w-140'> <input type='text' id='txtDosage_2' name='txtDosage_2' className='add-only' /> </td>
                   <td className='w-140'> <input type='text' id='txtFrequency_2' name='txtFrequency_2' className='add-only' /> </td>
                   <td className='w-140'> <input type='text' id='txtDuration_2' name='txtDuration_2' className='add-only' /> </td>
                   <td className='w-140'> <input type='text' id='txtPrescriber_2' name='txtPrescriber_2' className='add-only' /> </td>
                </tr>
                <tr>
                   <td className='w-190'> <input type='text' id='txtNameMedication_3' name='txtNameMedication_3' className='add-only' /> </td>
                   <td className='w-140'> <input type='text' id='txtDosage_3' name='txtDosage_3' className='add-only' /> </td>
                   <td className='w-140'> <input type='text' id='txtFrequency_3' name='txtFrequency_3' className='add-only' /> </td>
                   <td className='w-140'> <input type='text' id='txtDuration_3' name='txtDuration_3' className='add-only' /> </td>
                   <td className='w-140'> <input type='text' id='txtPrescriber_3' name='txtPrescriber_3' className='add-only' /> </td>
                </tr>
                <tr>
                   <td className='w-190'> <input type='text' id='txtNameMedication_4' name='txtNameMedication_4' className='add-only' /> </td>
                   <td className='w-140'> <input type='text' id='txtDosage_4' name='txtDosage_4' className='add-only' /> </td>
                   <td className='w-140'> <input type='text' id='txtFrequency_4' name='txtFrequency_4' className='add-only' /> </td>
                   <td className='w-140'> <input type='text' id='txtDuration_4' name='txtDuration_4' className='add-only' /> </td>
                   <td className='w-140'> <input type='text' id='txtPrescriber_4' name='txtPrescriber_4' className='add-only' /> </td>
                </tr>
                <tr>
                   <td className='w-190'> <input type='text' id='txtNameMedication_5' name='txtNameMedication_5' className='add-only' /> </td>
                   <td className='w-140'> <input type='text' id='txtDosage_5' name='txtDosage_5' className='add-only' /> </td>
                   <td className='w-140'> <input type='text' id='txtFrequency_5' name='txtFrequency_5' className='add-only' /> </td>
                   <td className='w-140'> <input type='text' id='txtDuration_5' name='txtDuration_5' className='add-only' /> </td>
                   <td className='w-140'> <input type='text' id='txtPrescriber_5' name='txtPrescriber_5' className='add-only' /> </td>
                </tr>
            </table>
            <table>
                    <tr>
                        <td className="w-750">
                            <span className="eleHeader">3. Are you <b>allergic</b> to any medications?</span>
                        </td>
                    </tr>
                    <tr>
                        <td className="w-150">
                            <input type="radio" id="rb_allergicMedications_No" name="rb_allergicMedications" className="add-only" value="0" /> No
                        </td>
                        <td className="w-150">
                            <input type="radio" id="rb_allergicMedications_yes" name="rb_allergicMedications" className="add-only" value="1" /> yes
                        </td>
                    </tr>
            </table>
            <b>If yes,</b>
            <p className='w-750'>
                    <span className='eleHeader'>Which ones?</span>
                    <textarea id="txtallergicMedications" name="txtallergicMedications" className='add-only'></textarea>
            </p>
            <table>
                    <tr>
                        <td className="w-750">
                            <span className="eleHeader">4.Do you have any other <b>allergies</b>?</span>
                        </td>
                    </tr>
                    <tr>
                        <td className="w-150">
                            <input type="radio" id="rb_otherAllergies_No" name="rb_otherAllergies" className="add-only" value="0" /> No
                        </td>
                        <td className="w-150">
                            <input type="radio" id="rb_otherAllergies_yes" name="rb_otherAllergies" className="add-only" value="1" /> yes
                        </td>
                    </tr>
            </table>
            <b>If yes,</b>
            <p className='w-750'>
                    <span className='eleHeader'>Describe them:</span>
                    <textarea id="txtDescribethem" name="txtDescribethem" className='add-only'></textarea>
            </p>
            <p className='w-750'>
                    <span className='eleHeader'>5. Who is your primary care physician? <br />When was the last time you saw your primary care physician and what was the purpose of that visit?</span>
                    <textarea id="txtprimaryCarePhysician" name="txtprimaryCarePhysician" className='add-only'></textarea>
            </p>
            <table>
                    <tr>
                        <td className="w-750">
                            <span className="eleHeader">6. Are you currently <b>pregnant</b>?</span>
                        </td>
                    </tr>
                    <tr>
                        <td className="w-150">
                            <input type="radio" id="rb_currentlyPregnant_1" name="rb_currentlyPregnant" className="add-only" value="1" /> No
                        </td>
                        <td className="w-150">
                            <input type="radio" id="rb_currentlyPregnant_2" name="rb_currentlyPregnant" className="add-only" value="2" /> yes
                        </td>
                        <td className="w-150">
                            <input type="radio" id="rb_currentlyPregnant_3" name="rb_currentlyPregnant" className="add-only" value="3" /> Unsure
                        </td>
                        <td className="w-150">
                            <input type="radio" id="rb_currentlyPregnant_4" name="rb_currentlyPregnant" className="add-only" value="4" /> N/A
                        </td>
                        
                    </tr>
            </table>
            <table>
                    <tr>
                        <td className="w-750">
                            <span className="eleHeader">7. Are there any <b>medical problems</b> that you are currently receiving treatment for?</span>
                        </td>
                    </tr>
                    <tr>
                        <td className="w-150">
                            <input type="radio" id="rb_currentlyReceivingTreatment_yes" name="rb_currentlyReceivingTreatment" className="add-only" value="0" /> yes
                        </td>
                        <td className="w-150">
                            <input type="radio" id="rb_currentlyReceivingTreatment_No" name="rb_currentlyReceivingTreatment" className="add-only" value="1" /> No
                        </td>
                    </tr>
            </table>
            <b>If No,Go to question 16.</b>
            <table>
                    <tr>
                        <td className="w-750">
                            <span className="eleHeader">8. Does your current medical condition(s) create problems in how you deal with life, including pain?</span>
                        </td>
                    </tr>
                    <tr>
                        <td className="w-150">
                            <input type="radio" id="rb_currentMedicalcondition_No" name="rb_currentMedicalcondition" className="add-only" value="0" /> No
                        </td>
                        <td className="w-150">
                            <input type="radio" id="rb_currentMedicalcondition_yes" name="rb_currentMedicalcondition" className="add-only" value="1" /> yes
                        </td>
                    </tr>
            </table>
            <b>If yes,</b>
            <p className='w-750'>
                    <span className='eleHeader'>- Explain:</span>
                    <textarea id="txtExplain" name="txtExplain" className='add-only'></textarea>
            </p>
            <table>
                    <tr>
                        <td className='signature w-375'>&nbsp; </td>
                        <td className='signature w-375'>&nbsp; </td>
                    </tr>
                    <tr>
                        <td className='small w-375'>Rectment or Legally Responsible Person / Date </td>
                        <td className='small w-375'>Agency Representative/ Date</td>
                    </tr>
            </table>
            <h3>CONSENT FOR TREATMENT</h3>
            <p className='w-750'>
                    <span className='eleHeader'>In signing this document, I am stating that I have read and agree to the following conditions regarding services rendered by Lei Behavioral Services, LLC:</span>
            </p>
            <ol className='w-750'>
                <li>I consent to and authorize treatment through Lei Behavioral Services, LLC.</li>
                <li>I authorize the collection of necessary administrative dates regarding me. I understand that such data shall be computerized for statistical, programming, and billing purposes. </li>
                <li>I understand information regarding me shall be collect responsibility and maintained in a confidential clinical record. Any such records or information shall remain confidential except in the following incidences:</li>
                  <ol type="a">
                    <li>Information required by third party payers and parties giving LEIBS authorization to provide said services shall be forwarded to them.</li>
                    <li>Records shall be open to Lei Behavioral Services, LLC staff as needed and to appropriate state mental health officials.</li>
                    <li>Information may be exchanged if I sign a written release form indicating the nature of information to be released.</li>
                    <li>Information, which indicates a severe threat to the life or safety or another person or to self, shall be forwarded to the threatened parties or appropriate agencies to the extent necessary to protect life and safety.</li>
                    <li>Information will be released if required under a court subpoena.</li>
                    <li>Suspected abuse or neglect shall be reported to Protective Services as mandated by the Code of Texas and Federal Law.</li>
                    <li>State and Federal law prohibits the disclosure of any information identifying a Recipient as receiving alcohol/drug services unless the Recipient consents in writing, the disclosure is allowed by court order, disclosure is made to medical personnel in a medical emergency, or to qualified personnel for research,audit, or program evaluations.</li>
                    <li>Federal Law does not protect any information abouta crime committed by a Recipient either at the program or against any person who works for the program or about any threat to commit such a crime.</li>
                  </ol>
                <li>I understand that all services will be provided regardless of gender,color, national origin, sexual orientation, religious preference, and a level of disability.</li>
                <li>If there is a medical or psychiatric emergency, I give permission for staff to seek emergency care on my behalf.</li>
                <li>Lei Behavioral Services, LLC staff may share information with my consent with other associated facilities such as group homes, Dept. of Social Services, Court Services, and Area Programs if a Recipient is seen in two or more of these agencies.</li>
                <li>I agree to satisfy my financial obligation with Lei Behavioral Services, LLC. I understand payment is due at the time services are rendered, unless payment arrangements are made.</li>
                <li>You have the right to accept or refuse any medication, procedure test or treatment. Exception to this right is when there is an emergency, court order or if the recipient is under 18 years old and his/her parent or guardian has given permission.</li>
            </ol>
            <table>
                    <tr>
                        <td className="w-750">
                            <span className="eleHeader">I understand that I will be receiving the following services provided by Lei Behavioral Services, LLC:</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-375'><input type='checkbox' id='cbLeiBehavioralServices_1' name='cbLeiBehavioralServices_1' className='add-only' value='Assessment-Reassessmen' />Assessment/Reassessmen</td>
                        <td className='w-375'><input type='checkbox' id='cbLeiBehavioralServices_2' name='cbLeiBehavioralServices_2' className='add-only' value='Medication_Training' />Medication Training and Support</td>
                    </tr>
                    <tr>
                        <td className='w-375'><input type='checkbox' id='cbLeiBehavioralServices_3' name='cbLeiBehavioralServices_3' className='add-only' value='Skills_Development' />Skills Development and Training</td>
                        <td className='w-375'><input type='checkbox' id='cbLeiBehavioralServices_4' name='cbLeiBehavioralServices_4' className='add-only' value='CriminalBehavior' />Routine Case Managemen</td>
                    </tr>
                    <tr>
                        <td className='w-375'><input type='checkbox' id='cbLeiBehavioralServices_5' name='cbLeiBehavioralServices_5' className='add-only' value='Family_Intervention_Counseling' />Individual /Family Intervention Counseling</td>
                        <td className='w-375'><input type='checkbox' id='cbLeiBehavioralServices_6' name='cbLeiBehavioralServices_6' className='add-only' value='PsychosocialSkills' />Psychosocial Skills Training</td>
                    </tr>
                    <tr>
                        <td className='w-750'><input type='checkbox' id='cbLeiBehavioralServices_7' name='cbLeiBehavioralServices_7' className='add-only' value='ConstantRestlessness' />Other:</td>
                    </tr>
                    <tr>
                        <td className='w-750'> <input type='text' id='txtLeiBehavioralServices_7' name='txtLeiBehavioralServices_7' className='add-only' /> </td>
                    </tr>
            </table>
            <table>
                    <tr>
                        <td className='signature w-375'>&nbsp; </td>
                        <td className='signature w-375'>&nbsp; </td>
                    </tr>
                    <tr>
                        <td className='small w-375'>Recipient or Legally Responsible Person I Date</td>
                        <td className='small w-375'>Agency Representative/ Date</td>
                    </tr>
            </table>
            <h3>Consent to Telehealth Services</h3>
            <p className='w-750'>
                    <span className='eleHeader'>Introduction:</span>
                    <b> Telemedicine involves the use of electronic communications to enable health care
                    providers at different locations to share individual patient medical information for the
                    purpose of improving patient care. LEIBS may include Psychiatrists, LPC's, and/or
                    LCSW's. The information may be used for diagnosis, therapy, follow-up and/or
                    education, and may include any of the following:</b>
            </p>
            <p className='w-750'>
               <ol>
                 <li>Patient medical records</li>
                 <li>Live two way audio and video </li>
                 <li>Output data from medical devices and sound and video files</li>
               </ol>
                    Electronic systems used will incorporate network and software security protocols to
                    protect the confidentiality of patient identification and imaging data and will include
                    measures to safeguard the data and to ensure its integrity against intentional or
                    unintentional corruption.
            </p>
            <p className='w-750'>
                    <span className='eleHeader'>Expected Benefits:</span>
                    Improved access to psychiatric care by enabling a patient to remain at home (or at a remote site).
            </p>
            <p className='w-750'>
                    <span className='eleHeader'>Possible Risks: </span>
                    <b>As with any medical procedure, there are potential risks associated
                    with the use of telemedicine. These risks include, but may not be limited to:</b>
                    <ol>
                        <li> In rare
                             cases, information transmitted may not be sufficient (e.g. poor resolution of images)
                             to allow for appropriate medical decision making by the psychiatrist and mental
                             health professional(s);
                        </li>
                        <li> Delays in mental evaluation and treatment could occur due
                             to deficiencies or failures of the equipment; 
                        </li>
                        <li>In very rare instances, security
                             protocols could fail, causing a breach of privacy of personal psychiatric information;
                             In rare cases, a lack of access to complete psychiatric records may result in adverse
                             drug interactions or allergic reactions or other judgment errors.
                        </li>
                    </ol>
            </p>
            <p className='w-750'>
                    <span className='eleHeader'>By signing this form, I understand the following:</span>
                    <ol>
                        <li>I understand that the laws that protect privacy and the confidentiality of medical information also apply to telemedicine, and that no information obtained in the use of telemedicine which identifies me will be disclosed to researchers or other entities without my consent.</li>
                        <li>I understand that I have the right to withhold or withdraw my consent to the use of telemedicine in the course of my care at any time, without affecting my right to future care or treatment.</li>
                        <li>I understand that I have the right to inspect all information obtained and recorded in the course of a telemedicine interaction, and may receive copies of this information.</li>
                        <li>I understand that a variety of alternative methods of medical care may be available to me, and that I may choose one or more of these at any time. My Mental Health Professional has explained the alternatives to my satisfaction.</li>
                        <li>I understand that I may expect the anticipated benefits from the use of telemedicine in my care, but that no results can be guaranteed or assured.</li>
                    </ol>
            </p>
            <p className='w-750'>
                    <span className='eleHeader'>Patient Consent to The Use of Telemedicine</span>
                    I have read and understand the information provided above regarding telemedicine,
                    have discussed it with my psychiatrist or such Mental Health Professional as may be
                    designated, and all of my questions have been answered to my satisfaction.
                    I hereby give my informed consent for the use of telemedicine in my medical care. 
                    I hereby authorize <input type="text" id="txtUseTelemedicine" name="txtUseTelemedicine" className='add-only w-375 custom-add-only' />
                    (Name of Mental Health Professional) to use telemedicine in the course of my diagnosis and treatment.
            </p>
            <table>
                    <tr>
                        <td className='signature w-375'>&nbsp; </td>
                        <td className='signature w-375'>&nbsp; </td>
                    </tr>
                    <tr>
                        <td className='small w-375'>Signature of Patient (or person authorized to sign for patient):</td>
                        <td className='small w-375'>Date:</td>
                    </tr>
            </table>
            <h3>Consent for Medication</h3>
            <table>
                <tr>
                    <td className='w-375'> <span className='eleHeader'>PHYSICIAN:</span> 
                    <input type='text' id='txtMedicationPhysician' name='txtMedicationPhysician' className='add-only' /></td>
                    <td className='w-375'><span className='eleHeader'>PATIENT'S NAME:</span>
                    <input type='text' id='txtMedicationPatientName' name='txtMedicationPatientName' className='add-only' /></td>
                </tr>
                <tr>
                    <td className='w-375'><span className='eleHeader'>DOB:</span>
                    <input type='text' id='txtMedicationDob' name='txtMedicationDob' className='add-only' /></td>
                    <td className='w-375'> <span className='eleHeader'>DATE:</span>
                    <input type='date' id='txtMedicationDate' name='txtMedicationDate' className='add-only' /></td> 
                </tr>
                <tr>
                  <td className='w-750'><span className='eleHeader'>MEDICAID ID:</span>
                    <input type='text' id='txtMedicaidId' name='txtMedicaidId' className='add-only' /></td>
                </tr>
            </table>
            <p className='w-750'>
                  I have received the information on medications(s)with the psychiatrist and
                  have had ample opportunity to have all my questions answered.I understand thata
                  bold and/or urine specimen may be needed somy doctor can monitor my psychopharmacotherapy.I also understand thatI mustconsenttoa urine drug screen
                  initially and periodically during treatment if I am being prescribed controlled
                  medications/ narcotics.
            </p>
            <table>
                    <tr>
                        <td className='signature w-375'>&nbsp; </td>
                        <td className='signature w-375'>&nbsp; </td>
                    </tr>
                    <tr>
                        <td className='small w-375'>Recipient Signature/ or Legally Responsible person</td>
                        <td className='small w-375'>Date:</td>
                    </tr>
                    <tr>
                        <td className='signature w-375'>&nbsp; </td>
                        <td className='signature w-375'>&nbsp; </td>
                    </tr>
                    <tr>
                        <td className='small w-375'>Agency Representative</td>
                        <td className='small w-375'>Date:</td>
                    </tr>
            </table>
            <h3>Medication Acknowledgement Waiver </h3>
            <p className='w-750'>
              <span className='eleHeader'>PATIENT'S NAME: </span>
              <input type='text' id='txtMedicationAcknowledePatientName' name='txtMedicationAcknowledePatientName' className='add-only' />
            </p>
            <p className='w-750'>
                     At this moment, I will not be receiving any medication management from the 
                     psychiatrist on site at Lei Behavioral Services, LLC. At my own will, I will be declining 
                     all medication management services with Lei Behavioral Services, LLC. 
            </p>
            <table>
                    <tr>
                        <td className='signature w-375'>&nbsp; </td>
                        <td className='signature w-375'>&nbsp; </td>
                    </tr>
                    <tr>
                        <td className='small w-375'>Recipient Signature/ or Legally Responsible person</td>
                        <td className='small w-375'>Date:</td>
                    </tr>
                    <tr>
                        <td className='signature w-375'>&nbsp; </td>
                        <td className='signature w-375'>&nbsp; </td>
                    </tr>
                    <tr>
                        <td className='small w-375'>Agency Representative</td>
                        <td className='small w-375'>Date:</td>
                    </tr>
            </table>
            <h3>PHARMACY INFORMATION </h3>
              <table>
              <tr>
                        <td className='w-375'>
                            <span className='eleHeader'>Pharmacy name: </span>
                            <input type='text' id="txtPharmacyInformationName" name="txtPharmacyInformationName" className='add-only' />
                        </td>
                        <td className='w-375'>
                            <span className='eleHeader'>Address: </span>
                            <input type='text' id="txtPharmacyInformationAddress" name="txtPharmacyInformationAddress" className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <span className='eleHeader'>Phone:</span>
                            <input type='text' id="txtPharmacyInformationPhone" name="txtPharmacyInformationPhone" className='add-only' />
                        </td>
                        <td className='w-375'>
                            <span className='eleHeader'>Fax:</span>
                            <input type='text' id="txtPharmacyInformationFax" name="txtPharmacyInformationFax" className='add-only' />
                        </td>
                    </tr>
              </table>
              <h3>CLIENT'S RIGHTS AND RESPONSIBILITIES </h3>
              <p className='w-750'>Lei Behavioral Services, LLC's policy is to protect the rights of each client. During the intake process, the client's
                     rights are reviewed in a manner that is understandable. The Corporate Compliance Officer responds to questions
                     and grievances pertaining to the client's rights and ensures compliance with Texas administrative code. Rule
                     §404.154. The client's rights and responsibilities are reviewed annually as listed below.
              </p>
              <p className='w-750'>
                 <span className='eleHeader'>CLIENT RIGHTS:</span>
                 <ol>
                    <li>to be informed ofthe client's rights and responsibilities at the time of admission orwithin 24 hours of admission;</li>
                    <li>to havea family member, chosen representative and/or his or her own physician notified of admission to the BHS provider at the request of the client;</li>
                    <li>to receive treatment and medical services without discrimination based on race, age, religion, national origin, gender, sexual orientation, or disability;</li>
                    <li>to maintain the personal dignity of each client;</li>
                    <li>to be free from abuse, neglect, exploitation and harassment;</li>
                    <li>to receive care in a safe setting; </li>
                    <li>to receive the services of a translator or interpreter, if applicable, to facilitate communication between the client and the staff</li>
                    <li>to be informed of the client's own health status and to participate in the development, implementation and updating of the client's treatment plan; </li>
                    <li>to make informed decisions regarding the client's care by the client or the client's parent or guardian, if applicable, in accordance with federal and state laws and regulations; </li>
                    <li>to participate or refuse to participate in experimental research when the client gives informed, written consent to such participation, or when a client's parent or legal guardian provides such consent, when applicable, in accordance with federal and state laws and regulations; </li>
                    <li>to be informed, in writing, of the policies and procedures for filinga grievance  and their review and resolution;</li>
                    <li>to submit complaints or grievances without fear of reprisal;</li>
                    <li>to have the client's information and medical records, including all computerized medical information, kept confidential in accordance with federal and state statutes and rules/regulations; </li>
                    <li>to be given a copy of the program's rules and regulations upon admission; </li>
                    <li>to receive treatment in the least restrictive environment that meets the client's needs;</li>
                    <li>to not be restrained or secluded in violation of federal and state laws, rules and regulations;</li>
                    <li>to be informed in advance of all estimated charges and any limitations on the length of services at the time of admission or within 72 hours (There are no out of pocket fees associated with services provided to Medicaid recipient's) </li>
                    <li>to receive an explanation of treatment or rights while in treatment;</li>
                    <li>to be informed of the:</li>
                     <ol type='a'>
                        <li>nature and purpose of any services rendered; </li>
                        <li>the title of personnel providing that service; </li>
                        <li>the risks, benefits, and side effects of all proposed freatment and medications; </li>
                        <li>the probable health and mental health consequences of refusing treatment; and </li>
                        <li>other available treatments which may be appropriate;</li>
                     </ol>
                    <li>to accept or refuse all or part of treatment, unless prohibited by court order or a physician deems the client to be a danger to self or others or gravely disabled; </li>
                    <li><b>to have a copy of these rights, which includes the information to contact Lei Behavioral Services, LLC located at: </b></li>
                 </ol>
              </p>
              <table>
                <tr>
                    <td className='w-120'></td>
                    <td className='w-500'>6201 Bonhomme Rd.</td>
                </tr>
                <tr>
                     <td className='w-120'></td>
                    <td className='w-500'>Suite 266N</td>
                </tr>
                <tr>
                     <td className='w-120'></td>
                    <td className='w-500'>Houston, TX 77036</td>
                </tr>
              </table>
              <p className='w-750'><span className='eleHeader'>CLIENT RESPONSIBILITIES: </span></p>
              <p className='w-750'> <b>To make your mental health treatment successful, we need to work together. The agency asks that all
                 clients provide clear, complete and truthful information at all times. We do our part by providing you
                 with information concerning your rights and the services we offer. Your part is to take responsibility for the following:</b>
                 </p>
              <p className='w-750'>
                 <ol>
                    <li>Follow agency rules, policies and procedures.</li>
                    <li>Follow the steps described in this handbook if you wish to file a grievance or appeal with our agency. </li>
                    <li>Keep scheduled appointments and call to cancel or reschedule if you cannot make your scheduled appointment. </li>
                    <li>Ask questions when you don't understand or when you want more information.</li>
                    <li>Provide any information to your worker that is necessary for your treatment.</li>
                    <li>Participate actively to create goals that will help you in your recovery. </li>
                    <li>Follow the treatment plans that you and your providers have agreed upon. </li>
                    <li>Take medications as they are prescribed for you.</li>
                    <li>Tell your doctor if you are having unpleasant side effects from your medications, or if your medications do not seem to be working to help you feel better.</li>
                    <li>Seek out additional support services in the community.</li>
                    <li>Invite the people (family, friends, etc.) who will be helpful and supportive to you to be included in your treatment.</li>
                    <li>Understand your rights and the grievance process.</li>
                    <li>Treat staff, as you would expect to be treated.</li>
                 </ol> 
              </p>
              <table>
                    <tr>
                        <td className='signature w-375'>&nbsp;
                        </td>
                        <td className='signature w-375'>&nbsp;
                        </td>
                    </tr>
                    <tr>
                        <td className='small w-375'>Recipient or Legally Responsible Person / Date 
                        </td>
                        <td className='small w-375'>Agency Representative/ Date 
                        </td>
                    </tr>
                </table>
                <h3>NOTIFICATION OF RECEIPT OF RECIPIENT RIGHTS</h3>
                <p className='w-750'>
                    I understand its contents regarding Recipient rights and responsibilities. I have received a copy of the
                    confidentiality notice, Recipient Handbook (which includes a summary of my rights), and Program Rules. I
                    have also been explained the services, including the benefits and risks, program rules and grievance procedure.
                </p>
                <p className='w-750'> I also understand that | may withdraw from Lei Behavioral Services, LLC anytime I feel treatment/services
                    are not beneficial to me. Staff has answered my questions regarding Recipient rights.
                </p>
                <p className='w-750'>
                    I also understand that specific programs may have additional policies and procedures pertaining to Recipient
                    rights and that those will be explained to me upon entry into the program.
                </p>
                <p className='w-750'>
                  <span className='eleHeader'>I have received the following information: </span>
                </p>
                <p className='w-750'>
                   <ol>
                    <li>Protections regarding disclosure of confidentiality; </li>
                    <li>Procedure for obtaining a copy of my treatment plan; </li>
                    <li>Policies addressing fee assessment and collection practices for my treatment rehabilitation; </li>
                    <li>Grievance policy/procedure;</li>
                    <li>Suspension and expulsion policy notification</li>
                    <li>Search and seizure policy notification;</li>
                   </ol>
                </p>
                <p className='w-750'>
                   LEIBS will implement the use of least restrictive intervention and most appropriate setting and
                   methods as a last resort. Lei Behavioral Services, LLC prohibits the contingent use of painful body
                   contact, or substances administered to induce bodily painful reactions exclusive. 
                </p>
                <h3>PRIVACY NOTICE ACKNOWLEDGMENT FORM (HIPPA) </h3>
                <p className='w-750'>
                    I acknowledge that I have been provided a copy of the Notice of Privacy Practices for Lei Behavioral
                    Services, LLC. I understand that the Notice of Privacy Practices discusses how my personal health care
                    information may be used and/or disclosed, my rights with respect to health care information, and how and
                    where I may file a privacy-related complaint. 
                </p>
                <p className='w-750'>
                  I may review a copy of the Notice from Lei Behavioral Services, LLC. 
                </p>
                <p className='w-750'>
                   I may obtain a copy of this from Lei Behavioral Services, LLC.  
                </p>
                <p className='w-750'>
                   I understand that the terms of this Notice may be changed in the future, and these changes will be
                   posted in Lei Behavioral Services, LLC office. I may also request a copy of the new Notice by
                   contacting the Privacy Officer. 
                </p>
                <h3>HOW TO MAKE A COMPLAINT OR FILING A GRIEVANCE </h3>
                <p className='w-750'>
                  <span className='eleHeader'> If you are dissatisfied with the services being provided by Lei Behavioral Services, LLC or if you
                   wish to file a grievance against perceived unfair treatment, the follow procedures can be followed:</span>
                </p>
                <p className='w-750'>
                  <ol>
                    <li>Begin by explaining your concern, complaint, or grievance to the Professional providing the service. </li>
                    <li>The treating professional will attempt to resolve the problem by scheduling a meeting in order to come to a joint decision. </li>
                    <li>If the contact with the professional does not resolve the problem, put your concern/grievance in
                         writing and ask for it to be reviewed in the Client Rights Committee for resolution. This can be
                         done so by completing a grievance form. Please feel free to ask a LEIBS staff for the form. An
                         appeal process will take place and a representative of the company will get back with you. 
                    </li>
                    <li>If the management and client rights committee is unable to resolve the issue to your satisfaction, you can seek legal advice as necessary at you own expense. </li>
                    <li>You can also contact the Office of Consumer Services and Rights Protection at 1800- 252-8154 </li>
                  </ol>
                </p>
                <h3>CRISIS RESPONSE SERVICE </h3>
                <p className='w-750'>
                  I have been informed that Lei Behavioral Services, LLC has a crisis response line (832-862-7997)
                  available 24hrs/7 days a week, 365 days a year for Recipient to use in crisis situations. A designated
                  on-call qualified professional will be responsible for responding to all crisis calls during and after
                  regular business hours. The on call qualified professional will be responsible for the implementation
                  of Crisis Plan via phone and face to face within two hours. The on call qualified professional will have
                  access to the crisis plan for each individual. 
                </p>
                <h3>RIGHT OF DETERMINATION APPEAL PROCESS </h3>
                <p className='w-750'>
                  LEIBS will not deny, interrupt, suspend, reduce or terminate your services without a good cause. If
                  you are a Medicaid recipient (or eligible to be one) and a decision has been made to deny, reduce,
                  suspend or terminate services being received, then you have the right to appeal the decision.
                  A notification of the decision will be sent by your MCO. If you need clarifications on any issues,
                  please contact Lei Behavioral Services, LLC immediately. We will assist you with the appeal process
                  follow up. 
                </p>
                <p className='w-750'>
                    Recipients maybe expelled or suspended from services when the agency can no longer meet the
                    recipient's needs or guarantee their safety. Lei Behavioral Services, LLC shail notify recipients once
                    a specific time is determined to restore services. Lei Behavioral Services, LLC shall make efforts to
                    recommend appropriate services that will meet recipient's needs and discharge plan if any. 
                </p>
                <h3>ABUSE/NEGLECT PROTOCOL/PROCEDURE </h3>
                <p className='w-750'>
                  It is your right to be free of harm, abuse, neglect and exploitation. Lei Behavioral Services, LLC
                  prohibits any abuse or neglectful conduct on the part of any individual employed or contracted by the
                  agency or serving in a consultative capacity. 
                </p>
                <p className='w-750'>
                   If for any reason, you have questions, concerns or complaints that involve any kind of abuse, sexual,
                   physical etc. you should call the Texas Department of Family and Protective Service at 1-800-
                   252-5400 
                </p>
                <table>
                    <tr>
                        <td className='signature w-375'>&nbsp;
                        </td>
                        <td className='signature w-375'>&nbsp;
                        </td>
                    </tr>
                    <tr>
                        <td className='small w-375'>Recipient or Legally Responsible Person / Date 
                        </td>
                        <td className='small w-375'>Agency Representative/ Date 
                        </td>
                    </tr>
                </table>
                <h3>EMERGENCY PREPARDNES QUESTIONNAIRE </h3>
                <p className='w-750'>
                  Please provide us with your updated emergency contact information and contact
                  information of your evacuation destination. 
                </p>
            <table>
              <tr>
                        <td className='w-375'>
                            <span className='eleHeader'>CLIENT NAME:</span>
                            <input type='text' id="txtEmergencyPrepardnesClientName" name="txtEmergencyPrepardnesClientName" className='add-only' />
                        </td>
                        <td className='w-375'>
                            <span className='eleHeader'>EMERGENCY CONTACT NAME: </span>
                            <input type='text' id="txtEmergencyPrepardnesEmer_contactNo" name="txtEmergencyPrepardnesEmer_contactNo" className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <span className='eleHeader'>ADDRESS: </span>
                            <input type='text' id="txtEmergencyPrepardnesAddress_1" name="txtEmergencyPrepardnesAddress_1" className='add-only' />
                        </td>
                        <td className='w-375'>
                            <span className='eleHeader'>ADDRESS: </span>
                            <input type='text' id="txtEmergencyPrepardnesAddress_2" name="txtEmergencyPrepardnesAddress_2" className='add-only' />
                        </td>
                    </tr>
                        <tr>
                        <td className='w-375'>
                            <span className='eleHeader'>PHONE NUMBER:</span>
                            <input type='text' id="txtEmergencyPrepardnesPhoneNo_1" name="txtEmergencyPrepardnesPhoneNo_1" className='add-only' />
                        </td>
                        <td className='w-375'>
                            <span className='eleHeader'>PHONE NUMBER:</span>
                            <input type='text' id="txtEmergencyPrepardnesPhoneNo_2" name="txtEmergencyPrepardnesPhoneNo_2" className='add-only' />
                        </td>
                    </tr>
              </table>
              <table>
                    <tr>
                        <td className='w-750'>
                            <span className='eleHeader'>Do you have somewhere to evacuate? </span><br />
                            <input type="radio" id="rbevacuate_yes_1" name="rbevacuate_1" className='add-only' value="Yes" /> Yes
                            &nbsp;
                            <input type="radio" id="rbevacuate_No_1" name="rbevacuate_1" className='add-only' value="No" /> No
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <span className='eleHeader'>Do you plan to evacuate? </span><br />
                            <input type="radio" id="rbevacuate_yes_2" name="rbevacuate_2" className='add-only' value="Yes" /> Yes
                            &nbsp;
                            <input type="radio" id="rbevacuate_No_2" name="rbevacuate_2" className='add-only' value="No" /> No
                        </td>
                    </tr>
                </table>
                <p className='w-750'> 
                    <span className='eleHeader'>If so, when? </span>
                    <input type='text' id="txtevacuateWhen" name="txtevacuateWhen" className='add-only' />
                </p>
                <table>
                    <tr>
                        <td className='w-750'>
                            <span className='eleHeader'>Do you plan to return? </span><br />
                            <input type="radio" id="rbPlanToreturn_yes" name="rbPlanToreturn" className='add-only' value="Yes" /> Yes
                            &nbsp;
                            <input type="radio" id="rbPlanToreturn_no" name="rbPlanToreturn" className='add-only' value="No" /> No
                        </td>
                    </tr>
                </table>
                <p className='w-750'> 
                    <span className='eleHeader'>Who will evacuate with you? </span>
                    <textarea id="txtevacuatewithyou" name="txtevacuatewithyou" className='add-only' ></textarea>
                </p>
                <table>
                    <tr>
                        <td className='w-750'>
                            <span className='eleHeader'>Do you have the necessities to evacuate? </span><br />
                            <input type="radio" id="rbNecessitiesEvacuate_yes" name="rbNecessitiesEvacuate" className='add-only' value="Yes" /> Yes
                            &nbsp;
                            <input type="radio" id="rbNecessitiesEvacuate_No" name="rbNecessitiesEvacuate" className='add-only' value="No" /> No
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <span className='eleHeader'>Do you currently own a cell phone? </span><br />
                            <input type="radio" id="rbOwnCellPhone_yes" name="rbOwnCellPhone" className='add-only' value="Yes" /> Yes
                            &nbsp;
                            <input type="radio" id="rbOwnCellPhone_No" name="rbOwnCellPhone" className='add-only' value="No" /> No
                        </td>
                    </tr>
                </table>
                <p className='w-750'> 
                    <span className='eleHeader'>If not, whom can we contact to reach you immediately </span>
                    <textarea id="txtReachImmediately" name="txtReachImmediately" className='add-only' ></textarea>
                </p>
                <table>
                    <tr>
                        <td className='w-750'>
                            <span className='eleHeader'>What is the best way to contact you? </span><br />
                            <input type="radio" id="rbWayContactYou_1" name="rbWayContactYou" className='add-only' value="Phone" /> Phone 
                            &nbsp;&nbsp;
                            <input type="radio" id="rbWayContactYou_2" name="rbWayContactYou" className='add-only' value="Text" /> Text
                            &nbsp;&nbsp;
                            <input type="radio" id="rbWayContactYou_3" name="rbWayContactYou" className='add-only' value="Email" /> Email
                            &nbsp;&nbsp;
                            <input type="radio" id="rbWayContactYou_4" name="rbWayContactYou" className='add-only' value="AllApply" />(Circle All That Apply) 
                        </td>
                    </tr>
                </table>
                <p className='w-750'> 
                    <span className='eleHeader'>Any additional information/ comments: </span>
                    <textarea id="txtAdditionalInfo_comment" name="txtAdditionalInfo_comment" className='add-only' ></textarea>
                </p>
                <table>
                    <tr>
                        <td className='signature w-375'>&nbsp;
                        </td>
                        <td className='signature w-375'>&nbsp;
                        </td>
                    </tr>
                    <tr>
                        <td className='small w-375'>Recipient or Legally Responsible Person / Date 
                        </td>
                        <td className='small w-375'>Agency Representative/ Date 
                        </td>
                    </tr>
                </table>
                <h3>Client Orientation Checklist</h3>
                <p className='w-750'> 
                    <span className='eleHeader'>Each client, parent, or legal guardian of a client will be instructed and given written information regarding the following, upon admission to Lei Behavioral Services, LLC's program: </span>
                    <ol>
                        <li>Informed Consent/Freedom of Choice </li>
                        <li>Non-discrimination provisions </li>
                        <li>family involvement;</li>
                        <li>safety;</li>
                        <li>the rules governing individual conduct;</li>
                        <li>authorization to provide treatment; </li>
                        <li>adverse reactions to treatment;</li>
                        <li>the general nature and goals of the program;</li>
                        <li>proposed treatment to include treatment methodology, duration, goals and services; </li>
                        <li>risks and consequences of non-compliance;</li>
                        <li>treatment alternatives; </li>
                        <li>Client's rights and responsibilities; </li>
                        <li>all other pertinent information, including fees and consequences of non-payment of fees; </li>
                    </ol>
                </p>
                <p className='w-750'> 
                    <span className='eleHeader'>Additional information will be provided throughout the intake process, including but not limited to: </span>
                    <ol>
                        <li>Grievance and Appeal Procedures </li>
                        <li>Communication/input policies regarding:</li>
                         <ol type='a'>
                            <li>Quality of Care </li>
                            <li> Outcome Achievement</li>
                            <li>Client Satisfaction </li>
                         </ol>
                        <li>Explanation of the agency's</li>
                         <ol type='a'>
                            <li>Mission/Philosophy/General nature and goals of the program </li>
                            <li>Services, activities, and therapeutic interventions </li>
                            <li>Family Participation/Involvement </li>
                            <li>Hours of Operation </li>
                            <li>24-Hour On Call Policy </li>
                            <li>Code of Ethics</li>
                            <li>Confidentiality Policy and HIPPA Privacy Rights </li>
                            <li>Requirements for follow-up for mandated clients, regardless of his/her discharge outcome.</li>
                         </ol>
                        <li>Explanation of any and all financial obligations, fees, and arrangements for services provided by the organization (There are no out of pocket fees associated with services provided to Medicaid recipient's). </li>
                        <li>Orientation with the agency facilities, including emergency exits, fire suppression equipment, and first aid kits. </li>
                        <li>The agency policies regarding safety and: </li>
                         <ol type='a'>
                            <li>Seclusion, restraints or physical holds </li>
                            <li>Smoking and Tabaco </li>
                            <li>licit or licit drugs </li>
                            <li>Weapons</li>
                            <li>Abuse and neglect </li>
                         </ol>
                        <li>Identification of direct care worker.</li>
                        <li>Program rules that identify:</li>
                         <ol type='a'>
                            <li>Any restrictions the program may place on clients.</li>
                            <li>Events, behaviors, or attitudes that may lead to the loss of rights or privileges for the client. </li>
                            <li>Means by which the client may regain rights or privileges that have been restricted.</li>
                         </ol>
                         <li>Identification of the purpose and process of assessment.</li>
                          <ol type='a'>
                             <li>Smoking and Tabaco </li>
                             <li>Illicit or licit drugs </li>
                             <li>Weapons </li>
                             <li>Abuse and neglect and exploitation </li>
                          </ol>
                        <li>Program rules governing individual conduct, risk and consequences of non-compliance </li>
                        <li>Education regarding Advanced Directives, where appropriate. </li>
                        <li>Authorization to provide treatment and adverse reactions to treatment. </li>
                        <li>A description of how the Treatment Plan will be developed, treatment methodology, duration, goals and services </li>
                        <li>information regarding transition, transfer and discharge criteria and procedures. </li>
                        <li>Treatment alternatives/Treatment approaches. </li>
                        <li>Non- payment fee, all client must maintain Medicaid eligible to avoid disruption of services. </li>
                        <li>Health and Safety concerns inclusive of physical and Environmental safety, Waste Management and  Infection Control Factors. </li>
                    </ol>
                </p>
                <p className='w-750'>
                    <b>By signing this acknowledgement, I agree to the terms of all contents of the Client Orientation/Intake Process and have received a copy of the Client Handbook. </b>
                </p>
                <table>
                    <tr>
                        <td className='signature w-375'>&nbsp;
                        </td>
                        <td className='signature w-375'>&nbsp;
                        </td>
                    </tr>
                    <tr>
                        <td className='small w-375'>Client/ Legally Responsible Person 
                        </td>
                        <td className='small w-375'>Date 
                        </td>
                    </tr>
                </table>
                <table>
                    <tr>
                        <td className='signature w-375'>&nbsp;
                        </td>
                        <td className='signature w-375'>&nbsp;
                        </td>
                    </tr>
                    <tr>
                        <td className='small w-375'>Agency Representative Signature  
                        </td>
                        <td className='small w-375'>Date
                        </td>
                    </tr>
                </table>
                <h3>Member's Freedom of Choice Form </h3>
                <p className='w-750'> 
                  <span className='eleHeader'>The provider I choose is: </span>
                  <textarea id="txtMemberFreedomProvider" name="txtMemberFreedomProvider" value="Lei Behavioral Services, LLC ,832-862-7997 "className='add-only' ></textarea>
                </p>
                <p className='w-750'>
                    By Signing below, I acknowledge that I freely choose to receive services from the above provider, and I acknowledge my responsibility to notify my previous provider in order to coordinate care. 
                </p>
                <table>
              <tr>
                        <td className='w-375'>
                            <span className='eleHeader'>Member Name: </span>
                            <input type='text' id="txtMemberFreedomMemberName" name="txtMemberFreedomMemberName" className='add-only' />
                        </td>
                        <td className='w-375'>
                            <span className='eleHeader'>Member Date of Birth: </span>
                            <input type='text' id="txtMemberFreedomMemberDob" name="txtMemberFreedomMemberDob" className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <span className='eleHeader'>Member Legal Guardian Signature: </span>
                            <input type='text' id="txtMemberFreedomGuardianSignature" name="txtMemberFreedomGuardianSignature" className='add-only' />
                        </td>
                        <td className='w-375'>
                            <span className='eleHeader'>Legal Guardian Name:  </span>
                            <input type='text' id="txtMemberFreedomGuardianName" name="txtMemberFreedomGuardianName" className='add-only' />
                        </td>
                    </tr>
                        <tr>
                        <td className='w-375'>
                            <span className='eleHeader'>Member's Insurance Provider: </span>
                            <input type='text' id="txtMemberFreedomInsuranceProvider" name="txtMemberFreedomInsuranceProvider" className='add-only' />
                        </td>
                        <td className='w-375'>
                            <span className='eleHeader'>Today's Date: </span>
                            <input type='date' id="dtEmergencyTodayDate" name="dtEmergencyTodayDate" className='add-only' />
                        </td>
                    </tr>
              </table>
              <p className='w-750'>
                 This provider assumes responsibility of coordinating care with the prior provider record. 
              </p>
              <table>
                    <tr>
                        <td className='signature w-375'>&nbsp;
                        </td>
                        <td className='signature w-375'>&nbsp;
                        </td>
                    </tr>
                    <tr>
                        <td className='small w-375'>Agency Representative Signature:  
                        </td>
                        <td className='small w-375'>Date:
                        </td>
                    </tr>
             </table>
            <h3>CONSENT TO RELEASE OR OBTAIN INFORMATION </h3>
             <table>
                <tr>
                    <td className='w-750'>
                        <p><b>Lei Behavioral Services, LLC </b></p>
                        <p><b>201 Bonkomme Rd (Ste 266N) </b></p>
                        <p><b>Houston, TX 77036 </b></p>
                        <p><b>Phone: 832-862-7997 </b></p>
                        <p><b>Fax:713-583-0722 </b></p>
                    </td>
                </tr>
                <tr>
                    <td className='w-750'>
                       <p><b>I,</b> <input type="text" id="txtconsentReleaseName_pg1" name="txtconsentReleaseName_pg1" className='add-only w-375 custom-add-only' /> request and authorize </p>
                    </td>
                </tr>
             </table>
             <table>
                <tr>
                    <td className='w-750'>
                      <span className='eleHeader'>To</span>
                    </td>
                </tr>
                <tr>
                    <td className='w-250'>
                      <input type="checkbox" id="cbObtain_healthcare_pg1" name="cbObtain_healthcare_pg1" className='add-only' value="obtain_healthcare_pg1" /> <b> obtain healthcare information </b>
                    </td>
                    <td  className='w-50'>
                       <b>OR</b>
                    </td>
                    <td className='w-450'>
                      <input type="checkbox" id="cbrelease_healthcare_pg1" name="cbrelease_healthcare_pg1" className='add-only' value="release_healthcare_pg1" /><b> release healthcare information of the recipient named above from/to:</b> 
                    </td>
                </tr>
             </table>
             <table>
                <tr>
                   <td className='w-375'> <span className='eleHeader'>Name: </span> 
                   <span className='small'>(Primary Care Dr Information) </span></td>
                   <td className='w-375'> <span className='eleHeader'>Address: </span> </td> 
                </tr>
                <tr>
                   <td className='w-375'> <input type='text' id='txtconsentReleasInfoName_pg1' name='txtconsentReleasInfoName_pg1' className='add-only' /> </td>
                   <td className='w-375'> <input type='text' id='txtconsentReleasInfoAddress_pg1' name='txtconsentReleasInfoAddress_pg1' className='add-only' /> </td>
                </tr>
                <tr>
                   <td className='w-250'> <span className='eleHeader'>City/State/Zip</span> </td> 
                   <td className='w-250'> <span className='eleHeader'>Phone:</span> </td>
                   <td className='w-250'> <span className='eleHeader'>Fax:</span> </td>
                </tr>
                <tr>
                   <td className='w-250'> <input type='text' id='txtconsentReleasInfoCity_State_Zip_pg1' name='txtconsentReleasInfoCity_State_Zip_pg1' className='add-only' /> </td>
                   <td className='w-250'> <input type='text' id='txtconsentReleasInfoPhone_pg1' name='txtconsentReleasInfoPhone_pg1' className='add-only' /> </td>
                   <td className='w-250'> <input type='text' id='txtconsentReleasInfoFax_pg1' name='txtconsentReleasInfoFax_pg1' className='add-only' /> </td>
                </tr>
             </table>
             <table>
                <tr>
                    <td className='w-750'>
                      <span className='eleHeader'>This request and authorization apply to:</span> 
                    </td>
                </tr>
                <tr>
                        <td className='w-750'><input type='checkbox' id='cbAuthorizationApplyTo_1_pg1' name='cbAuthorizationApplyTo_1_pg1' className='add-only' value='AuthorizationApplyTo_1_pg1' /><b>All Healthcare information relating to the following treatment, condition, or dates: </b>
                        <input type='text' id='txtAuthorizationApplyTo_1_pg1' name='txtAuthorizationApplyTo_1_pg1' className='add-only' /></td>
                    </tr>
                    <tr>
                        <td className='w-250'><input type='checkbox' id='cbAuthorizationApplyTo_2_pg1' name='cbAuthorizationApplyTo_2_pg1' className='add-only' value='AuthorizationApplyTo_2_pg1' />Clinical Evaluation </td>
                        <td className='w-250'><input type='checkbox' id='cbAuthorizationApplyTo_3_pg1' name='cbAuthorizationApplyTo_3_pg1' className='add-only' value='AuthorizationApplyTo_3_pg1' />Psychological Evaluation </td>
                        <td className='w-250'><input type='checkbox' id='cbAuthorizationApplyTo_4_pg1' name='cbAuthorizationApplyTo_4_pg1' className='add-only' value='AuthorizationApplyTo_4_pg1' />Psychiatric Evaiuation</td>
                    </tr>
                    <tr>
                        <td className='w-250'><input type='checkbox' id='cbAuthorizationApplyTo_5_pg1' name='cbAuthorizationApplyTo_5_pg1' className='add-only' value='AuthorizationApplyTo_5_pg1' />Social History </td>
                        <td className='w-250'><input type='checkbox' id='cbAuthorizationApplyTo_6_pg1' name='cbAuthorizationApplyTo_6_pg1' className='add-only' value='AuthorizationApplyTo_6_pg1' /> Medical History. Examination. Reports</td>
                        <td className='w-250'><input type='checkbox' id='cbAuthorizationApplyTo_7_pg1' name='cbAuthorizationApplyTo_7_pg1' className='add-only' value='AuthorizationApplyTo_7_pg1' />Discharge Summary </td>
                    </tr>
                    <tr>
                        <td className='w-250'><input type='checkbox' id='cbAuthorizationApplyTo_8_pg1' name='cbAuthorizationApplyTo_8_pg1' className='add-only' value='AuthorizationApplyTo_8_pg1' />Laboratory Results </td>
                        <td className='w-250'><input type='checkbox' id='cbAuthorizationApplyTo_9_pg1' name='cbAuthorizationApplyTo_9_pg1' className='add-only' value='AuthorizationApplyTo_9_pg1' />Quarterly Summary </td>
                        <td className='w-250'><input type='checkbox' id='cbAuthorizationApplyTo_10_pg1' name='cbAuthorizationApplyTo_10_pg1' className='add-only' value='AuthorizationApplyTo_10_pg1' />Treatment Plan </td>
                    </tr>
                    <tr>
                        <td className='w-250'><input type='checkbox' id='cbAuthorizationApplyTo_11_pg1' name='cbAuthorizationApplyTo_11_pg1' className='add-only' value='AuthorizationApplyTo_11_pg1' />Doctor's Progress Notes </td>
                        <td className='w-250'><input type='checkbox' id='cbAuthorizationApplyTo_12_pg1' name='cbAuthorizationApplyTo_12_pg1' className='add-only' value='AuthorizationApplyTo_12_pg1' />Pharmacy Notes </td>
                    </tr>
                    <tr>
                      <td className='w-750'><input type='checkbox' id='cbAuthorizationApplyTo_13_pg1' name='cbAuthorizationApplyTo_13_pg1' className='add-only' value='AuthorizationApplyTo_13_pg1' />Other:
                      <input type='text' id='txtAuthorizationApplyTo_13_pg1' name='txtAuthorizationApplyTo_13_pg1' className='add-only' /> </td>
                    </tr>
                </table>
                <p className='w-750'>This consent is subject to written revocation at any time except to the extent that action has already been taken in reliance upon this consent, This 
                                     autherization shall expire on <input type="date" id="txtconsentReleaseDate_pg1" name="txtconsentReleaseDate_pg1" className='add-only w-375 custom-add-only' /> (date or event). 
                                     I understand that if I do not specify an expiration date/event, this authorization shall expire one year from the date of consent. 
                </p>
                <p className='w-750'>I understand that the treatment/services are not contingent upon my signing or not signing this authorization. I freely and voluntarily give my authorization for the release of information from my health record. I also understand and authorize that this information may be sent via facsimile transmission. </p>
                <p className='w-750'><span className='eleHeader'>TO PARTIES RECEIVING THIS INFORMATION:</span>  This information has been disclosed to you from records whose confidentiality is protected
                                     by federal law. Federal regulations (42 CFR, Part 2) prohibit you from making farther disclosures of it without specific written consent of the
                                     person to whom it pertains. A general authorization for the release of health or other information is not sufficient for this purpose.
                 </p>
                 <table>
                    <tr>
                        <td className='signature w-375'>&nbsp;
                        </td>
                        <td className='signature w-375'>&nbsp;
                        </td>
                    </tr>
                    <tr>
                        <td className='small w-375'>Recipient / Legally Responsible Person Signature: 
                        </td>
                        <td className='small w-375'>Date Signed: 
                        </td>
                    </tr>
                </table>
                <table>
                    <tr>
                        <td className='signature w-375'>&nbsp;
                        </td>
                        <td className='signature w-375'>&nbsp;
                        </td>
                    </tr>
                    <tr>
                        <td className='small w-375'>Agency Representative Signature  
                        </td>
                        <td className='small w-375'>Date Signed: 
                        </td>
                    </tr>
                </table>
            <h3>CONSENT TO RELEASE OR OBTAIN INFORMATION </h3>
             <table>
                <tr>
                    <td className='w-750'>
                        <p><b>Lei Behavioral Services, LLC </b></p>
                        <p><b>201 Bonkomme Rd (Ste 266N) </b></p>
                        <p><b>Houston, TX 77036 </b></p>
                        <p><b>Phone: 832-862-7997 </b></p>
                        <p><b>Fax:713-583-0722 </b></p>
                    </td>
                </tr>
                <tr>
                    <td className='w-750'>
                       <p><b>I,</b> <input type="text" id="txtconsentReleaseName_pg2" name="txtconsentReleaseName_pg2" className='add-only w-375 custom-add-only' /> request and authorize </p>
                    </td>
                </tr>
             </table>
             <table>
                <tr>
                    <td className='w-750'>
                      <span className='eleHeader'>To</span>
                    </td>
                </tr>
                <tr>
                    <td className='w-250'>
                      <input type="checkbox" id="cbObtain_healthcare_pg2" name="cbObtain_healthcare_pg2" className='add-only' value="obtain_healthcare_pg2" /> <b> obtain healthcare information </b>
                    </td>
                    <td  className='w-50'>
                       <b>OR</b>
                    </td>
                    <td className='w-450'>
                      <input type="checkbox" id="cbrelease_healthcare_pg2" name="cbrelease_healthcare_pg2" className='add-only' value="release_healthcare_pg2" /><b> release healthcare information of the recipient named above from/to:</b> 
                    </td>
                </tr>
             </table>
             <table>
                <tr>
                   <td className='w-375'> <span className='eleHeader'>Name: </span> 
                   <span className='small'>(Emergency contact Information)</span></td>
                   <td className='w-375'> <span className='eleHeader'>Address: </span> </td> 
                </tr>
                <tr>
                   <td className='w-375'> <input type='text' id='txtconsentReleasInfoName_pg2' name='txtconsentReleasInfoName_pg2' className='add-only' /> </td>
                   <td className='w-375'> <input type='text' id='txtconsentReleasInfoAddress_pg2' name='txtconsentReleasInfoAddress_pg2' className='add-only' /> </td>
                </tr>
                <tr>
                   <td className='w-250'> <span className='eleHeader'>City/State/Zip</span> </td> 
                   <td className='w-250'> <span className='eleHeader'>Phone:</span> </td>
                   <td className='w-250'> <span className='eleHeader'>Fax:</span> </td>
                </tr>
                <tr>
                   <td className='w-250'> <input type='text' id='txtconsentReleasInfoCity_State_Zip_pg2' name='txtconsentReleasInfoCity_State_Zip_pg2' className='add-only' /> </td>
                   <td className='w-250'> <input type='text' id='txtconsentReleasInfoPhone_pg2' name='txtconsentReleasInfoPhone_pg2' className='add-only' /> </td>
                   <td className='w-250'> <input type='text' id='txtconsentReleasInfoFax_pg2' name='txtconsentReleasInfoFax_pg2' className='add-only' /> </td>
                </tr>
             </table>
             <table>
                <tr>
                    <td className='w-750'>
                      <span className='eleHeader'>This request and authorization apply to:</span> 
                    </td>
                </tr>
                <tr>
                        <td className='w-750'><input type='checkbox' id='cbAuthorizationApplyTo_1_pg2' name='cbAuthorizationApplyTo_1_pg2' className='add-only' value='AuthorizationApplyTo_1_pg2' /><b>All Healthcare information relating to the following treatment, condition, or dates: </b>
                        <input type='text' id='txtAuthorizationApplyTo_1_pg2' name='txtAuthorizationApplyTo_1_pg2' className='add-only' /></td>
                    </tr>
                    <tr>
                        <td className='w-250'><input type='checkbox' id='cbAuthorizationApplyTo_2_pg2' name='cbAuthorizationApplyTo_2_pg2' className='add-only' value='AuthorizationApplyTo_2_pg2' />Clinical Evaluation </td>
                        <td className='w-250'><input type='checkbox' id='cbAuthorizationApplyTo_3_pg2' name='cbAuthorizationApplyTo_3_pg2' className='add-only' value='AuthorizationApplyTo_3_pg2' />Psychological Evaluation </td>
                        <td className='w-250'><input type='checkbox' id='cbAuthorizationApplyTo_4_pg2' name='cbAuthorizationApplyTo_4_pg2' className='add-only' value='AuthorizationApplyTo_4_pg2' />Psychiatric Evaiuation</td>
                    </tr>
                    <tr>
                        <td className='w-250'><input type='checkbox' id='cbAuthorizationApplyTo_5_pg2' name='cbAuthorizationApplyTo_5_pg2' className='add-only' value='AuthorizationApplyTo_5_pg2' />Social History </td>
                        <td className='w-250'><input type='checkbox' id='cbAuthorizationApplyTo_6_pg2' name='cbAuthorizationApplyTo_6_pg2' className='add-only' value='AuthorizationApplyTo_6_pg2' /> Medical History. Examination. Reports</td>
                        <td className='w-250'><input type='checkbox' id='cbAuthorizationApplyTo_7_pg2' name='cbAuthorizationApplyTo_7_pg2' className='add-only' value='AuthorizationApplyTo_7_pg2' />Discharge Summary </td>
                    </tr>
                    <tr>
                        <td className='w-250'><input type='checkbox' id='cbAuthorizationApplyTo_8_pg2' name='cbAuthorizationApplyTo_8_pg2' className='add-only' value='AuthorizationApplyTo_8_pg2' />Laboratory Results </td>
                        <td className='w-250'><input type='checkbox' id='cbAuthorizationApplyTo_9_pg2' name='cbAuthorizationApplyTo_9_pg2' className='add-only' value='AuthorizationApplyTo_9_pg2' />Quarterly Summary </td>
                        <td className='w-250'><input type='checkbox' id='cbAuthorizationApplyTo_10_pg2' name='cbAuthorizationApplyTo_10_pg2' className='add-only' value='AuthorizationApplyTo_10_pg2' />Treatment Plan </td>
                    </tr>
                    <tr>
                        <td className='w-250'><input type='checkbox' id='cbAuthorizationApplyTo_11_pg2' name='cbAuthorizationApplyTo_11_pg2' className='add-only' value='AuthorizationApplyTo_11_pg2' />Doctor's Progress Notes </td>
                        <td className='w-250'><input type='checkbox' id='cbAuthorizationApplyTo_12_pg2' name='cbAuthorizationApplyTo_12_pg2' className='add-only' value='AuthorizationApplyTo_12_pg2' />Pharmacy Notes </td>
                    </tr>
                    <tr>
                      <td className='w-750'><input type='checkbox' id='cbAuthorizationApplyTo_13_pg2' name='cbAuthorizationApplyTo_13_pg2' className='add-only' value='AuthorizationApplyTo_13_pg2' />Other:
                      <input type='text' id='txtAuthorizationApplyTo_13_pg2' name='txtAuthorizationApplyTo_13_pg2' className='add-only' /> </td>
                    </tr>
                </table>
                <p className='w-750'>This consent is subject to written revocation at any time except to the extent that action has already been taken in reliance upon this consent, This 
                                     autherization shall expire on <input type="date" id="txtconsentReleaseDate_pg2" name="txtconsentReleaseDate_pg2" className='add-only w-375 custom-add-only'/> (date or event). 
                                     I understand that if I do not specify an expiration date/event, this authorization shall expire one year from the date of consent. 
                </p>
                <p className='w-750'>I understand that the treatment/services are not contingent upon my signing or not signing this authorization. I freely and voluntarily give my authorization for the release of information from my health record. I also understand and authorize that this information may be sent via facsimile transmission. </p>
                <p className='w-750'><span className='eleHeader'>TO PARTIES RECEIVING THIS INFORMATION:</span>This information has been disclosed to you from records whose confidentiality is protected
                                     by federal law. Federal regulations (42 CFR, Part 2) prohibit you from making farther disclosures of it without specific written consent of the
                                     person to whom it pertains. A general authorization for the release of health or other information is not sufficient for this purpose.
                 </p>
                 <table>
                    <tr>
                        <td className='signature w-375'>&nbsp;
                        </td>
                        <td className='signature w-375'>&nbsp;
                        </td>
                    </tr>
                    <tr>
                        <td className='small w-375'>Recipient / Legally Responsible Person Signature: 
                        </td>
                        <td className='small w-375'>Date Signed: 
                        </td>
                    </tr>
                </table>
                <table>
                    <tr>
                        <td className='signature w-375'>&nbsp;
                        </td>
                        <td className='signature w-375'>&nbsp;
                        </td>
                    </tr>
                    <tr>
                        <td className='small w-375'>Agency Representative Signature  
                        </td>
                        <td className='small w-375'>Date Signed: 
                        </td>
                    </tr>
                </table>

            <h3>Consumer Satisfaction Survey - Intake and Screening </h3>
             <table>
                <tr>
                    <td className='w-750'>
                      <b>Please complete the following survey regarding your service received from Lei Behavioral Services, LLC. Please choose your answer using the scale from Strongly Disagree to Strongly Agree. </b>
                    </td>
                </tr>
                <tr>
                    <td className='w-250'></td>
                    <td className='w-100'> <span className='eleHeader'>Strongly Disagree</span></td>
                    <td className='w-100'> <span className='eleHeader'>Disagree</span></td>
                    <td className='w-100'> <span className='eleHeader'>Neither Disagree nor Agree </span></td>
                    <td className='w-100'> <span className='eleHeader'>Agree</span></td>
                    <td className='w-100'> <span className='eleHeader'>Strongly Agree</span></td>
                </tr>
             </table>
             <table>
                <tr>
                   <td className='w-250'><b>1.</b> Safety of the agency location if applicable </td>
                   <center><td className='w-100'><input type="radio" id="rb_StronglyDisagree_1" name="rb_ConsumerSatisfactionSurvey_1" className="add-only" value="StronglyDisagree_1" /></td>
                   <td className='w-100'><input type="radio" id="rb_Disagree_1" name="rb_ConsumerSatisfactionSurvey_1" className="add-only" value="Disagree_1" /></td>
                   <td className='w-100'><input type="radio" id="rb_DisagreeNorAgree_1" name="rb_ConsumerSatisfactionSurvey_1" className="add-only" value="DisagreeNorAgree_1" /></td>
                   <td className='w-100'><input type="radio" id="rb_Agree_1" name="rb_ConsumerSatisfactionSurvey_1" className="add-only" value="Agree_1" /></td>
                   <td className='w-100'><input type="radio" id="rb_StronglyAgree_1" name="rb_ConsumerSatisfactionSurvey_1" className="add-only" value="StronglyAgree_1" /></td>
                   </center>
                </tr>
                <tr>
                   <td className='w-250'><b>2.</b> Cleanliness of the agency if applicable </td>
                   <center><td className='w-100'><input type="radio" id="rb_StronglyDisagree_2" name="rb_ConsumerSatisfactionSurvey_2" className="add-only" value="StronglyDisagree_2" /></td>
                   <td className='w-100'><input type="radio" id="rb_Disagree_2" name="rb_ConsumerSatisfactionSurvey_2" className="add-only" value="Disagree_2" /></td>
                   <td className='w-100'><input type="radio" id="rb_DisagreeNorAgree_2" name="rb_ConsumerSatisfactionSurvey_2" className="add-only" value="DisagreeNorAgree_2" /></td>
                   <td className='w-100'><input type="radio" id="rb_Agree_2" name="rb_ConsumerSatisfactionSurvey_2" className="add-only" value="Agree_2" /></td>
                   <td className='w-100'><input type="radio" id="rb_StronglyAgree_2" name="rb_ConsumerSatisfactionSurvey_2" className="add-only" value="StronglyAgree_2" /></td>
                   </center>
                </tr>
                <tr>
                   <td className='w-250'><b>3.</b> Ability of staff to put me at ease with the enrollment process </td>
                   <center><td className='w-100'><input type="radio" id="rb_StronglyDisagree_3" name="rb_ConsumerSatisfactionSurvey_3" className="add-only" value="StronglyDisagree_3" /></td>
                   <td className='w-100'><input type="radio" id="rb_Disagree_3" name="rb_ConsumerSatisfactionSurvey_3" className="add-only" value="Disagree_3" /></td>
                   <td className='w-100'><input type="radio" id="rb_DisagreeNorAgree_3" name="rb_ConsumerSatisfactionSurvey_3" className="add-only" value="DisagreeNorAgree_3" /></td>
                   <td className='w-100'><input type="radio" id="rb_Agree_3" name="rb_ConsumerSatisfactionSurvey_3" className="add-only" value="Agree_3" /></td>
                   <td className='w-100'><input type="radio" id="rb_StronglyAgree_3" name="rb_ConsumerSatisfactionSurvey_3" className="add-only" value="StronglyAgree_3" /></td>
                   </center>
                </tr>
                <tr>
                   <td className='w-250'><b>4.</b> Courtesy of the person assisting </td>
                   <center><td className='w-100'><input type="radio" id="rb_StronglyDisagree_4" name="rb_ConsumerSatisfactionSurvey_4" className="add-only" value="StronglyDisagree_4" /></td>
                   <td className='w-100'><input type="radio" id="rb_Disagree_4" name="rb_ConsumerSatisfactionSurvey_4" className="add-only" value="Disagree_4" /></td>
                   <td className='w-100'><input type="radio" id="rb_DisagreeNorAgree_4" name="rb_ConsumerSatisfactionSurvey_4" className="add-only" value="DisagreeNorAgree_4" /></td>
                   <td className='w-100'><input type="radio" id="rb_Agree_4" name="rb_ConsumerSatisfactionSurvey_4" className="add-only" value="Agree_4" /></td>
                   <td className='w-100'><input type="radio" id="rb_StronglyAgree_4" name="rb_ConsumerSatisfactionSurvey_4" className="add-only" value="StronglyAgree_4" /></td>
                   </center>
                </tr>
                <tr>
                   <td className='w-250'><b>5.</b> Time taken to get help with someone who could assist me </td>
                   <center><td className='w-100'><input type="radio" id="rb_StronglyDisagree_5" name="rb_ConsumerSatisfactionSurvey_5" className="add-only" value="StronglyDisagree_5" /></td>
                   <td className='w-100'><input type="radio" id="rb_Disagree_5" name="rb_ConsumerSatisfactionSurvey_5" className="add-only" value="Disagree_5" /></td>
                   <td className='w-100'><input type="radio" id="rb_DisagreeNorAgree_5" name="rb_ConsumerSatisfactionSurvey_5" className="add-only" value="DisagreeNorAgree_5" /></td>
                   <td className='w-100'><input type="radio" id="rb_Agree_5" name="rb_ConsumerSatisfactionSurvey_5" className="add-only" value="Agree_5" /></td>
                   <td className='w-100'><input type="radio" id="rb_StronglyAgree_5" name="rb_ConsumerSatisfactionSurvey_5" className="add-only" value="StronglyAgree_5" /></td>
                   </center>
                </tr>
                <tr>
                   <td className='w-250'><b>6.</b> Knowledge of the staff handling the enrollment </td>
                   <center><td className='w-100'><input type="radio" id="rb_StronglyDisagree_6" name="rb_ConsumerSatisfactionSurvey_6" className="add-only" value="StronglyDisagree_6" /></td>
                   <td className='w-100'><input type="radio" id="rb_Disagree_6" name="rb_ConsumerSatisfactionSurvey_6" className="add-only" value="Disagree_6" /></td>
                   <td className='w-100'><input type="radio" id="rb_DisagreeNorAgree_6" name="rb_ConsumerSatisfactionSurvey_6" className="add-only" value="DisagreeNorAgree_6" /></td>
                   <td className='w-100'><input type="radio" id="rb_Agree_6" name="rb_ConsumerSatisfactionSurvey_6" className="add-only" value="Agree_6" /></td>
                   <td className='w-100'><input type="radio" id="rb_StronglyAgree_6" name="rb_ConsumerSatisfactionSurvey_6" className="add-only" value="StronglyAgree_6" /></td>
                   </center>
                </tr>
                <tr>
                   <td className='w-250'><b>7.</b> Overall satisfaction with the first encounter with the agency </td>
                   <center><td className='w-100'><input type="radio" id="rb_StronglyDisagree_7" name="rb_ConsumerSatisfactionSurvey_7" className="add-only" value="StronglyDisagree_7" /></td>
                   <td className='w-100'><input type="radio" id="rb_Disagree_7" name="rb_ConsumerSatisfactionSurvey_7" className="add-only" value="Disagree_7" /></td>
                   <td className='w-100'><input type="radio" id="rb_DisagreeNorAgree_7" name="rb_ConsumerSatisfactionSurvey_7" className="add-only" value="DisagreeNorAgree_7" /></td>
                   <td className='w-100'><input type="radio" id="rb_Agree_7" name="rb_ConsumerSatisfactionSurvey_7" className="add-only" value="Agree_7" /></td>
                   <td className='w-100'><input type="radio" id="rb_StronglyAgree_7" name="rb_ConsumerSatisfactionSurvey_7" className="add-only" value="StronglyAgree_7" /></td>
                   </center>
                </tr>
                <tr>
                   <td className='w-250'><b>8.</b> Effort Taken by staff to getting any problems resolved </td>
                   <center><td className='w-100'><input type="radio" id="rb_StronglyDisagree_8" name="rb_ConsumerSatisfactionSurvey_8" className="add-only" value="StronglyDisagree_8" /></td>
                   <td className='w-100'><input type="radio" id="rb_Disagree_8" name="rb_ConsumerSatisfactionSurvey_8" className="add-only" value="Disagree_8" /></td>
                   <td className='w-100'><input type="radio" id="rb_DisagreeNorAgree_8" name="rb_ConsumerSatisfactionSurvey_8" className="add-only" value="DisagreeNorAgree_8" /></td>
                   <td className='w-100'><input type="radio" id="rb_Agree_8" name="rb_ConsumerSatisfactionSurvey_8" className="add-only" value="Agree_8" /></td>
                   <td className='w-100'><input type="radio" id="rb_StronglyAgree_8" name="rb_ConsumerSatisfactionSurvey_8" className="add-only" value="StronglyAgree_8" /></td>
                   </center>
                </tr>
                <tr>
                   <td className='w-250'><b>9.</b> Professionalism of the intake staff</td>
                   <center><td className='w-100'><input type="radio" id="rb_StronglyDisagree_9" name="rb_ConsumerSatisfactionSurvey_9" className="add-only" value="StronglyDisagree_9" /></td>
                   <td className='w-100'><input type="radio" id="rb_Disagree_9" name="rb_ConsumerSatisfactionSurvey_9" className="add-only" value="Disagree_9" /></td>
                   <td className='w-100'><input type="radio" id="rb_DisagreeNorAgree_9" name="rb_ConsumerSatisfactionSurvey_9" className="add-only" value="DisagreeNorAgree_9" /></td>
                   <td className='w-100'><input type="radio" id="rb_Agree_9" name="rb_ConsumerSatisfactionSurvey_9" className="add-only" value="Agree_9" /></td>
                   <td className='w-100'><input type="radio" id="rb_StronglyAgree_9" name="rb_ConsumerSatisfactionSurvey_9" className="add-only" value="StronglyAgree_9" /></td>
                   </center>
                </tr>
                <tr>
                   <td className='w-250'><b>10.</b> Individual differences are respected </td>
                   <center><td className='w-100'><input type="radio" id="rb_StronglyDisagree_10" name="rb_ConsumerSatisfactionSurvey_10" className="add-only" value="StronglyDisagree_10" /></td>
                   <td className='w-100'><input type="radio" id="rb_Disagree_10" name="rb_ConsumerSatisfactionSurvey_10" className="add-only" value="Disagree_10" /></td>
                   <td className='w-100'><input type="radio" id="rb_DisagreeNorAgree_10" name="rb_ConsumerSatisfactionSurvey_10" className="add-only" value="DisagreeNorAgree_10" /></td>
                   <td className='w-100'><input type="radio" id="rb_Agree_10" name="rb_ConsumerSatisfactionSurvey_10" className="add-only" value="Agree_10" /></td>
                   <td className='w-100'><input type="radio" id="rb_StronglyAgree_10" name="rb_ConsumerSatisfactionSurvey_10" className="add-only" value="StronglyAgree_10" /></td>
                   </center>
                </tr>
                <tr>
                   <td className='w-250'><b>11.</b> Time taken to get my questions answered </td>
                   <center><td className='w-100'><input type="radio" id="rb_StronglyDisagree_11" name="rb_ConsumerSatisfactionSurvey_11" className="add-only" value="StronglyDisagree_11" /></td>
                   <td className='w-100'><input type="radio" id="rb_Disagree_11" name="rb_ConsumerSatisfactionSurvey_11" className="add-only" value="Disagree_11" /></td>
                   <td className='w-100'><input type="radio" id="rb_DisagreeNorAgree_11" name="rb_ConsumerSatisfactionSurvey_11" className="add-only" value="DisagreeNorAgree_11" /></td>
                   <td className='w-100'><input type="radio" id="rb_Agree_11" name="rb_ConsumerSatisfactionSurvey_11" className="add-only" value="Agree_11" /></td>
                   <td className='w-100'><input type="radio" id="rb_StronglyAgree_11" name="rb_ConsumerSatisfactionSurvey_11" className="add-only" value="StronglyAgree_11" /></td>
                   </center>
                </tr>
                <tr>
                   <td className='w-250'><b>12.</b> Ability of the staff to help me understand the goal and objectives of the services provided </td>
                   <center><td className='w-100'><input type="radio" id="rb_StronglyDisagree_12" name="rb_ConsumerSatisfactionSurvey_12" className="add-only" value="StronglyDisagree_12" /></td>
                   <td className='w-100'><input type="radio" id="rb_Disagree_12" name="rb_ConsumerSatisfactionSurvey_12" className="add-only" value="Disagree_12" /></td>
                   <td className='w-100'><input type="radio" id="rb_DisagreeNorAgree_12" name="rb_ConsumerSatisfactionSurvey_12" className="add-only" value="DisagreeNorAgree_12" /></td>
                   <td className='w-100'><input type="radio" id="rb_Agree_12" name="rb_ConsumerSatisfactionSurvey_12" className="add-only" value="Agree_12" /></td>
                   <td className='w-100'><input type="radio" id="rb_StronglyAgree_12" name="rb_ConsumerSatisfactionSurvey_12" className="add-only" value="StronglyAgree_12" /></td>
                   </center>
                </tr>
                <tr>
                   <td className='w-250'><b>13.</b> Staff demonstration to explain legal and ethical aspects of client confidentiality  </td>
                   <center><td className='w-100'><input type="radio" id="rb_StronglyDisagree_13" name="rb_ConsumerSatisfactionSurvey_13" className="add-only" value="StronglyDisagree_13" /></td>
                   <td className='w-100'><input type="radio" id="rb_Disagree_13" name="rb_ConsumerSatisfactionSurvey_13" className="add-only" value="Disagree_13" /></td>
                   <td className='w-100'><input type="radio" id="rb_DisagreeNorAgree_13" name="rb_ConsumerSatisfactionSurvey_13" className="add-only" value="DisagreeNorAgree_13" /></td>
                   <td className='w-100'><input type="radio" id="rb_Agree_13" name="rb_ConsumerSatisfactionSurvey_13" className="add-only" value="Agree_13" /></td>
                   <td className='w-100'><input type="radio" id="rb_StronglyAgree_13" name="rb_ConsumerSatisfactionSurvey_13" className="add-only" value="StronglyAgree_13" /></td>
                   </center>
                </tr>
                <tr>
                   <td className='w-250'><b>14.</b> Interest of staff in leamning about what I want from services offered  </td>
                   <center><td className='w-100'><input type="radio" id="rb_StronglyDisagree_14" name="rb_ConsumerSatisfactionSurvey_14" className="add-only" value="StronglyDisagree_14" /></td>
                   <td className='w-100'><input type="radio" id="rb_Disagree_14" name="rb_ConsumerSatisfactionSurvey_14" className="add-only" value="Disagree_14" /></td>
                   <td className='w-100'><input type="radio" id="rb_DisagreeNorAgree_14" name="rb_ConsumerSatisfactionSurvey_14" className="add-only" value="DisagreeNorAgree_14" /></td>
                   <td className='w-100'><input type="radio" id="rb_Agree_14" name="rb_ConsumerSatisfactionSurvey_14" className="add-only" value="Agree_14" /></td>
                   <td className='w-100'><input type="radio" id="rb_StronglyAgree_14" name="rb_ConsumerSatisfactionSurvey_14" className="add-only" value="StronglyAgree_14" /></td>
                   </center>
                </tr>
                <tr>
                   <td className='w-250'><b>15.</b> Overall satisfaction with the screening process </td>
                   <center><td className='w-100'><input type="radio" id="rb_StronglyDisagree_15" name="rb_ConsumerSatisfactionSurvey_15" className="add-only" value="StronglyDisagree_15" /></td>
                   <td className='w-100'><input type="radio" id="rb_Disagree_15" name="rb_ConsumerSatisfactionSurvey_15" className="add-only" value="Disagree_15" /></td>
                   <td className='w-100'><input type="radio" id="rb_DisagreeNorAgree_15" name="rb_ConsumerSatisfactionSurvey_15" className="add-only" value="DisagreeNorAgree_15" /></td>
                   <td className='w-100'><input type="radio" id="rb_Agree_15" name="rb_ConsumerSatisfactionSurvey_15" className="add-only" value="Agree_15" /></td>
                   <td className='w-100'><input type="radio" id="rb_StronglyAgree_15" name="rb_ConsumerSatisfactionSurvey_15" className="add-only" value="StronglyAgree_15" /></td>
                   </center>
                </tr>
                <tr>
                   <td className='w-250'><b>16.</b> Based on your experience to date, what is the likelihood of you recommending this agency to others? </td>
                   <center><td className='w-100'><input type="radio" id="rb_StronglyDisagree_16" name="rb_ConsumerSatisfactionSurvey_16" className="add-only" value="StronglyDisagree_16" /></td>
                   <td className='w-100'><input type="radio" id="rb_Disagree_16" name="rb_ConsumerSatisfactionSurvey_16" className="add-only" value="Disagree_16" /></td>
                   <td className='w-100'><input type="radio" id="rb_DisagreeNorAgree_16" name="rb_ConsumerSatisfactionSurvey_16" className="add-only" value="DisagreeNorAgree_16" /></td>
                   <td className='w-100'><input type="radio" id="rb_Agree_16" name="rb_ConsumerSatisfactionSurvey_16" className="add-only" value="Agree_16" /></td>
                   <td className='w-100'><input type="radio" id="rb_StronglyAgree_16" name="rb_ConsumerSatisfactionSurvey_16" className="add-only" value="StronglyAgree_16" /></td>
                   </center>
                </tr>
                <tr>
                   <td className='w-250'><b>17.</b> What is your overall assessment of the agency  </td>
                   <center><td className='w-100'><input type="radio" id="rb_StronglyDisagree_17" name="rb_ConsumerSatisfactionSurvey_17" className="add-only" value="StronglyDisagree_17" /></td>
                   <td className='w-100'><input type="radio" id="rb_Disagree_17" name="rb_ConsumerSatisfactionSurvey_17" className="add-only" value="Disagree_17" /></td>
                   <td className='w-100'><input type="radio" id="rb_DisagreeNorAgree_17" name="rb_ConsumerSatisfactionSurvey_17" className="add-only" value="DisagreeNorAgree_17" /></td>
                   <td className='w-100'><input type="radio" id="rb_Agree_17" name="rb_ConsumerSatisfactionSurvey_17" className="add-only" value="Agree_17" /></td>
                   <td className='w-100'><input type="radio" id="rb_StronglyAgree_17" name="rb_ConsumerSatisfactionSurvey_17" className="add-only" value="StronglyAgree_17" /></td>
                   </center>
                </tr>
             </table>
                <h3 className='w-750'>Lei Behavioral Services, LLC </h3>
                <p className='w-750'><b>NOTICE OF PRIVACY PRACTICES </b></p>
                <h5 className='w-750'>THIS NOTICE DESCRIBES HOW MEDICAL INFORMATION ABOUT YOU MAY BE USED AND DISCLOSED AND HOW YOU CAN GET ACCESS TO THIS INFORMATION.</h5>
                <h5  className='w-750'>PLEASE REVIEW IT CAREFULLY. </h5>
                <p className='w-750'><b>If you have any questions about this Notice, please contact: </b></p>
                <p className='w-750'><b>Privacy Officer <br />Lei Behavioral Services, LLC</b></p>
                <p className='w-750'><b>Location<br />6201 Bonhomme Rd (Suite 266N) <br />Houston, TX 77036 <br />Phone: 832-862-7997 </b></p>
                <p className='w-750'>This notice describes how medical information about a recipient may be used and disclosed and how to gain access to the above information. Please review it carefully. </p>
                <p className='w-750'>All information that is provided during the screening, admission, and treatment/rehabilitation process is
                                     considered confidential by the employees, interns, and volunteers of Lei Behavioral Services, LLC.
                                     We are required to protect the privacy of health information of a recipient, and the disclosure of
                                     protected health information will be governed by the Health Insurance Portability and Accountability
                                     Act of 1996, as well as any other applicable federal or state laws. 
                </p>
                <p className='w-750'><span className='eleHeader'>Exchange and use of protected health information between Lei Behavioral Services, LL.C staff and/or
                      Lei Behavioral Services, LLC programs for the purpose of treatment, payment, or healthcare
                      operations will be permitted and based on “need to know” guidelines, and positional authority. For
                      example: </span>
                      <ul>
                        <li>Information obtained about a recipient by a psychiatrist, therapist, case manager, nurse or other member of the treatment team will be recorded in recipient's record and used to determine the course of treatment that should work best for the recipient. </li>
                        <li>Treatment team members will also be expected to discuss recipient progress with treatment on a routine basis. </li>
                        <li>Information about the services received will be submitted and processed by the billing department so that the Agency can be paid, or the recipient can be reimbursed. </li>
                        <li>Recipient medical record may also be pulled for review by the Quality Improvement department in preparation for an audit or for other internal reviews to improve the quality and effectiveness of the services being provided. </li>
                      </ul>
                </p>
                <p className='w-750'>
                      Disclosure of protected health information outside of Lei Behavioral Services, LLC is permitted when 
                      recipient or their legal representative signs a written authorization or gives verbal authorization in an 
                      emergency situation. Any authorization for disclosure may be revoked at any time, except to the 
                      extent that action has been taken in reliance on it. 
                </p>
                <p className='w-750'><span className='eleHeader'>Recipients have the right to request restriction of the disclosure of their health information, except 
                      when Lei Behavioral Services, LLC is required to do so. Even without recipient specific consent, Lei 
                      Behavioral Services, LLC may disclose information to someone outside of Lei Behavioral Services, 
                      LLC (and in some cases Lei Behavioral Services, LLC may even be required by law or professional 
                      ethics to disclose recipient information), in the following situations: </span>
                    <ul>
                        <li>When there is a medical or psychiatric emergency involving recipient health or safety or safety of others. </li>
                        <li>When Lei Behavioral Services, LLC is required by law to report instances of neglect or abuse of a child or disabled adult. </li>
                        <li>Disclosure in a legal proceeding, where Lei Behavioral Services, LLC is responding to an order of a court or administrative fribunal. </li>
                        <li>When Lei Behavioral Services, LLC is required by Texas Administrative Code to disclose to the physician, information due to an incident which would cause health risk to other persons. </li>
                        <li>When Lei Behavioral Services, LLC authorizes research for the purpose of program planning and evaluation of services through the use of statistical information that cannot be linked to the recipient as an individual. </li>
                    </ul> 
                </p>
                <p className='w-750'> Recipients also have other rights related to the use and disclosure of health information in their medical record.</p>
                <h4 className='w-750'>These rights include: </h4>
                <p className='w-750'><span className='eleHeader'>Right to request recipient medical record be designated as secured </span>
                   All medical records are considered to be secure and confidential. Recipient may restrict the
                   disclosure of their medical records only for the purpose of treatment, payment or healthcare
                   operations. Lei Behavioral Services, LLC will make every effort to accommodate recipient request, but
                   we are not required to do so. For example, if the information is the subject of a lawsuit or legal claim or
                   if release of the information may present a danger to you or someone else. 
                </p>
                <p className='w-750'><span className='eleHeader'>Right to inspect and request a copy of recipient medical record.</span>
                    If recipients would like to inspect or receive a copy of their health information, please contact Lei 
                    Behavioral Services, LLC for instructions on how to submit a written request. The agency may deny 
                    recipient request in very limited circumstances. If request is denied, Lei Behavioral Services, LLC will 
                    respond to the recipient in writing, stating why the request was not granted and describing any rights 
                    to request a review for denial. If recipient request is approved, the agency may charge a reasonable 
                    fee for the costs of copying, mailing or other supplies associated with any request for copies. 
                </p>
                <p className='w-750'><span className='eleHeader'>Right to request amendment of any section of recipient medical record. </span>
                     If recipients feel that the agency has information that is inaccurate or incomplete, recipients have the 
                     right to request amendments of record. If request is denied, the agency will notify recipient in writing of 
                     the reason and will describe recipient rights to provide a written statement disagreeing with the denial. 

                </p>
                <p className='w-750'><span className='eleHeader'>Right to receive an accounting of disclosures that have occurred. </span>
                   Each disclosure of protected health information will be documented in the medical record. Recipients
                   have the right to request an accounting of the disclosures of previous years, if any. 
                </p>
                <p className='w-750'><span className='eleHeader'>Right to request an alternative method of contact. </span>
                  Lei Behavioral Services, LLC may call recipients or mait information regarding appointment reminders,
                  billing information, or other information about treatment alternatives or services that might be of
                  interest. If recipients would like to request an alternative method of contact, please notify the agency.
                  Lei Behavioral Services, LLC will accommodate reasonable requests, but may condition our
                  accommodation on recipients providing, information regarding how payment, if any, will be handled.  
                </p>
                <p className='w-750'><span className='eleHeader'>Right to a copy of this Notice. </span>
                    Recipients have the right to receive a paper copy of this Notice. Lei Behavioral Services, LLC reserves
                    the right to change this notice and to make the new notice effective for all protected health information
                    that is maintained in hard copy or electronic format. Revisions to the <b>NOTICE OF PRIVACY PRACTICES </b>
                    will be made available at each facility for distribution to all recipients. 
                </p>
                <p className='w-750'>Lei Behavioral Services, LLC recognizes the importance of confidentiality, and recipient's right to be
                          fully informed of all regulations regarding protected health information.
                 </p>
                 <p className='w-750'><span className='eleHeader'>If recipients feel that their privacy rights have been violated, they may contact: </span></p>
                   <p className='w-750'><b>Lei Behavioral Services, LLC<br /></b>832-862-7997 </p>
                   <p className='w-750'><b>OR</b></p>
                   <h4 className='w-750'>Office of Consumer Services and Rights Protection </h4>
                   <p className='w-750'>Phone: (800) 252.8154 <br />Fax: (512) 706-7353 </p>
                   <p className='w-750'>1106 Clayton Lane <br />Austin,Texas 78723 <br />mail code:H700</p>
                   <p className='w-750'><b>OR</b></p>
                   <p className='w-750'>Texas Department of Family and Protective Service </p>
                   <h6 className='w-750'>Call: 1-800-252-5400 <br />If you can't use the Texas Abuse Hotline you can. Report online a <br /><a href="www.TxAbuseHotline.orgExternal Link ">www.TxAbuseHotline.orgExternal Link </a></h6>
                   <p className='w-750'><b>Provision of services will not be affected by the filing of any complaint. </b></p>
            </div>
        </form>
)}














